var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroRulesBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 429,
    height: 448,
    viewBox: "0 0 429 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5001_64747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.62 100.931H143.635V100.95H143.62V100.931Z",
    fill: "url(#paint0_linear_5001_64747)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-29.053 121.242H-24.5305L-17.4312 68.3163H-15.6945L-11.9396 111.005L-9.76578 109.12C-9.58716 108.965 -9.3553 108.877 -9.11587 108.877H-3.89785C-3.65842 108.877 -3.43423 108.961 -3.25181 109.112L10.9543 121.242H39.8833V105.811C39.8833 105.565 40.0885 105.364 40.3355 105.364C40.5826 105.364 40.784 105.164 40.784 104.917V101.775C40.784 101.631 40.8182 101.488 40.879 101.359L44.7935 92.943C44.9569 92.5947 45.3103 92.3713 45.698 92.3713H74.3685C74.7409 92.3713 75.083 92.5795 75.254 92.9089L79.4269 101.018C79.5941 101.347 79.9399 101.556 80.3124 101.556H80.396C80.9433 101.556 81.3879 101.999 81.3879 102.544V103.153C81.3879 103.483 81.2245 103.793 80.9471 103.979L80.8179 104.062C80.5443 104.244 80.377 104.554 80.377 104.883V121.242H85.9104L85.8801 114.007C85.8763 113.42 86.7123 113.318 86.8567 113.886L87.1912 115.241H87.4306L87.6397 113.784C87.7233 113.208 88.5632 113.224 88.6278 113.803L88.7836 115.241H89.4183L89.6273 113.784C89.7109 113.208 90.5508 113.224 90.6154 113.803L90.7598 115.143H90.9232L91.1171 113.788C91.2007 113.212 92.0406 113.227 92.1052 113.807L92.2496 115.147H92.9109L93.1047 113.791C93.1883 113.216 94.0282 113.231 94.0928 113.81L94.2372 115.151H94.4007L94.5945 113.795C94.6781 113.22 95.518 113.235 95.5826 113.814L95.727 115.154H95.8904L96.0842 113.799C96.1678 113.224 97.0077 113.239 97.0723 113.818L97.2168 115.158H97.6082L98.0111 113.511C98.1517 112.94 98.9954 113.046 98.9878 113.632L98.927 121.261H105.342V94.0674H105.521L105.623 93.1928C105.688 92.6212 106.516 92.606 106.608 93.1739L106.748 94.0674H107.136L107.239 93.1928C107.303 92.6212 108.132 92.606 108.223 93.1739L108.375 94.1696H112.164L112.278 93.1928C112.343 92.6212 113.171 92.606 113.262 93.1739L113.414 94.1696H113.775L113.889 93.1928C113.954 92.6212 114.782 92.606 114.874 93.1739L115.026 94.1696H115.219V100.889H116.025V86.0339H116.166C116.166 86.0339 116.17 86.0074 116.17 85.996L116.31 84.1902C116.356 83.5883 117.238 83.5769 117.298 84.1788L117.481 85.9847C117.481 85.9847 117.485 85.9998 117.485 86.0074V86.0301L117.58 86.0339V85.996L117.72 84.1902C117.766 83.5883 118.647 83.5769 118.708 84.1788L118.898 85.9847V86.015V86.0339H120.263V72.8366C120.259 72.8063 120.259 72.7722 120.263 72.7381V72.5753H120.297L120.559 71.5002C120.677 71.0156 121.357 70.9929 121.513 71.4623L121.882 72.5716H122.11L123.793 67.1465L124.614 56.4895C123.869 56.3986 123.288 55.7626 123.288 54.9941C123.288 54.1612 123.964 53.4873 124.804 53.4873C125.644 53.4873 126.313 54.1612 126.313 54.9941C126.313 55.8269 125.637 56.5008 124.804 56.5008H124.778L125.507 67.1465L127.385 72.5716H127.704L127.795 72.087C127.894 71.5645 128.639 71.5418 128.768 72.0605L128.894 72.5753H129.342V86.0339H129.889V85.996L130.03 84.1902C130.075 83.5883 130.957 83.5769 131.018 84.1788L131.208 85.9847V86.0339H133.522V85.996L133.663 84.1902C133.709 83.5883 134.59 83.5769 134.651 84.1788L134.841 85.9847V86.015V86.0339H134.997V100.889H137.521V94.1696H137.714L137.866 93.1739C137.95 92.6023 138.778 92.6212 138.851 93.1928L138.961 94.1696H139.33L139.478 93.1739C139.569 92.6023 140.397 92.6212 140.466 93.1928L140.576 94.1696H144.369L144.521 93.1739C144.605 92.6023 145.433 92.6212 145.505 93.1928L145.604 94.0674H145.996L146.129 93.1739C146.22 92.6023 147.048 92.6212 147.117 93.1928L147.215 94.0674H147.295V121.261H157.982V114.306C157.982 113.712 158.841 113.621 158.966 114.204L159.194 115.264H159.476V115.253V115.238L159.658 114.291C159.761 113.742 160.555 113.761 160.635 114.314L160.775 115.26L160.965 115.264V115.253C160.965 115.253 160.965 115.241 160.969 115.238L161.148 114.291C161.25 113.742 162.045 113.761 162.125 114.314L162.265 115.26L162.949 115.264V115.238L163.132 114.291C163.234 113.742 164.029 113.761 164.108 114.314L164.249 115.26L166.921 115.264V115.238L167.103 114.291C167.206 113.742 168 113.761 168.08 114.314L168.22 115.26L169.57 115.264L169.798 114.204C169.923 113.625 170.782 113.716 170.782 114.306V121.261H175.046V117.653C175.046 117.494 175.084 117.335 175.16 117.195L178.843 110.21C179.01 109.884 179.352 109.68 179.721 109.68H185.136C185.672 109.68 186.105 109.248 186.105 108.715C186.105 108.181 186.539 107.749 187.075 107.749H188.99C189.537 107.749 189.982 107.306 189.982 106.761V101.976C189.982 101.431 190.427 100.988 190.974 100.988H208.969C209.516 100.988 209.961 101.431 209.961 101.976V106.761C209.961 107.306 210.405 107.749 210.953 107.749H211.489C212.036 107.749 212.48 108.192 212.48 108.737V111.372V173.101H-29.053V121.242ZM143.635 100.931H143.62V100.95H143.635V100.931Z",
    fill: "url(#paint1_linear_5001_64747)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.241 66.123C281.241 65.8631 281.455 65.6501 281.716 65.6501L282.411 26.3978L282.39 25.6724L282.426 25.5605L282.411 26.3978L283.575 65.762C283.835 65.762 284.049 65.975 284.049 66.2349V70.9528H284.524C284.785 70.9528 284.999 71.1658 284.999 71.4257V73.328C285.343 73.642 285.575 74.0788 285.618 74.5733L285.716 75.8006C285.868 77.5983 285.865 79.4068 285.698 81.2044L285.626 81.9769C285.546 82.8432 284.886 83.5291 284.049 83.6662V87.9365H284.524C284.785 87.9365 284.999 88.1495 284.999 88.4094V88.8823C284.999 89.1422 284.785 89.3552 284.524 89.3552H284.049V91.7123H284.524C284.785 91.7123 284.999 91.9253 284.999 92.1852V93.1273C284.999 93.3872 284.785 93.6002 284.524 93.6002H284.049V97.3724H284.524C284.785 97.3724 284.999 97.5853 284.999 97.8452V98.7874C284.999 99.0473 284.785 99.2602 284.524 99.2602H284.049V99.7331H284.524C284.785 99.7331 284.999 99.9461 284.999 100.206V101.148C284.999 101.408 284.785 101.621 284.524 101.621H284.049V102.563H284.995C285.256 102.563 285.47 102.776 285.47 103.036V106.339C285.47 106.599 285.256 106.812 284.995 106.812H284.52V116.717C284.781 116.717 284.995 116.93 284.995 117.19V118.132C284.995 118.392 284.781 118.605 284.52 118.605V119.547C284.781 119.547 284.995 119.76 284.995 120.02V120.962C284.995 121.222 284.781 121.435 284.52 121.435V132.282H285.466C285.727 132.282 285.941 132.495 285.941 132.755V137.678H289.521C290.039 137.678 290.467 138.101 290.467 138.621V139.353H300.16V136.397C300.16 136.115 299.936 135.888 299.653 135.888C299.37 135.888 299.142 135.661 299.142 135.379V133.585C299.142 133.174 298.805 132.838 298.388 132.838C297.87 132.838 297.504 132.314 297.689 131.827L302.179 120.031C302.316 119.662 302.664 119.421 303.063 119.421H359.005C359.342 119.421 359.65 119.594 359.82 119.883L366.912 131.834C367.173 132.278 366.858 132.838 366.336 132.838C365.973 132.838 365.669 133.134 365.669 133.502V134.942C365.669 135.462 365.249 135.884 364.723 135.884H364.578C364.06 135.884 363.633 136.307 363.633 136.827V139.346H369.854V116.587C369.854 116.352 370.046 116.161 370.282 116.161C370.517 116.161 370.713 115.97 370.713 115.735V107.277C370.713 106.758 371.134 106.335 371.659 106.335H387.27V105.393C387.27 104.873 387.694 104.451 388.216 104.451H392.488C392.905 104.451 393.274 104.18 393.394 103.783L395.59 96.6288C395.709 96.2317 396.079 95.961 396.496 95.961H450.007C450.525 95.961 450.952 96.3833 450.952 96.9031V139.35V189.187H215.152V139.249V120.919C215.152 120.724 215.214 120.532 215.326 120.373L224.549 107.339C224.643 107.205 224.766 107.104 224.9 107.039V106.703H252.842C253.259 106.703 253.629 106.974 253.748 107.371L255.944 114.526C256.064 114.923 256.433 115.194 256.85 115.194H261.122C261.64 115.194 262.068 115.616 262.068 116.136V139.245H270.591V138.512C270.591 137.993 271.015 137.57 271.537 137.57H279.349V132.647C279.349 132.387 279.563 132.174 279.824 132.174H280.77V121.326C280.509 121.326 280.295 121.113 280.295 120.854V119.911C280.295 119.652 280.509 119.439 280.77 119.439V118.496C280.509 118.496 280.295 118.283 280.295 118.024V117.081C280.295 116.822 280.509 116.609 280.77 116.609V106.703H280.295C280.034 106.703 279.82 106.491 279.82 106.231V102.928C279.82 102.668 280.034 102.455 280.295 102.455H281.241V101.513H280.766C280.505 101.513 280.292 101.3 280.292 101.04V100.098C280.292 99.8378 280.505 99.6248 280.766 99.6248H281.241V99.1519H280.766C280.505 99.1519 280.292 98.939 280.292 98.6791V97.7369C280.292 97.477 280.505 97.2641 280.766 97.2641H281.241V93.4919H280.766C280.505 93.4919 280.292 93.2789 280.292 93.019V92.0769C280.292 91.817 280.505 91.604 280.766 91.604H281.241V89.2469H280.766C280.505 89.2469 280.292 89.0339 280.292 88.774V88.3011C280.292 88.0412 280.505 87.8282 280.766 87.8282H281.241V83.5796C280.418 83.5327 279.73 82.9118 279.618 82.0852C279.281 79.6306 279.266 77.1471 279.574 74.6925L279.61 74.3748C279.676 73.8767 279.926 73.4471 280.292 73.1511V71.3138C280.292 71.0539 280.505 70.8409 280.766 70.8409H281.241V66.123Z",
    fill: "url(#paint2_linear_5001_64747)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.241 66.123C281.241 65.8631 281.455 65.6501 281.716 65.6501L282.411 26.3978L282.39 25.6724L282.426 25.5605L282.411 26.3978L283.575 65.762C283.835 65.762 284.049 65.975 284.049 66.2349V70.9528H284.524C284.785 70.9528 284.999 71.1658 284.999 71.4257V73.328C285.343 73.642 285.575 74.0788 285.618 74.5733L285.716 75.8006C285.868 77.5983 285.865 79.4068 285.698 81.2044L285.626 81.9769C285.546 82.8432 284.886 83.5291 284.049 83.6662V87.9365H284.524C284.785 87.9365 284.999 88.1495 284.999 88.4094V88.8823C284.999 89.1422 284.785 89.3552 284.524 89.3552H284.049V91.7123H284.524C284.785 91.7123 284.999 91.9253 284.999 92.1852V93.1273C284.999 93.3872 284.785 93.6002 284.524 93.6002H284.049V97.3724H284.524C284.785 97.3724 284.999 97.5853 284.999 97.8452V98.7874C284.999 99.0473 284.785 99.2602 284.524 99.2602H284.049V99.7331H284.524C284.785 99.7331 284.999 99.9461 284.999 100.206V101.148C284.999 101.408 284.785 101.621 284.524 101.621H284.049V102.563H284.995C285.256 102.563 285.47 102.776 285.47 103.036V106.339C285.47 106.599 285.256 106.812 284.995 106.812H284.52V116.717C284.781 116.717 284.995 116.93 284.995 117.19V118.132C284.995 118.392 284.781 118.605 284.52 118.605V119.547C284.781 119.547 284.995 119.76 284.995 120.02V120.962C284.995 121.222 284.781 121.435 284.52 121.435V132.282H285.466C285.727 132.282 285.941 132.495 285.941 132.755V137.678H289.521C290.039 137.678 290.467 138.101 290.467 138.621V139.353H300.16V136.397C300.16 136.115 299.936 135.888 299.653 135.888C299.37 135.888 299.142 135.661 299.142 135.379V133.585C299.142 133.174 298.805 132.838 298.388 132.838C297.87 132.838 297.504 132.314 297.689 131.827L302.179 120.031C302.316 119.662 302.664 119.421 303.063 119.421H359.005C359.342 119.421 359.65 119.594 359.82 119.883L366.912 131.834C367.173 132.278 366.858 132.838 366.336 132.838C365.973 132.838 365.669 133.134 365.669 133.502V134.942C365.669 135.462 365.249 135.884 364.723 135.884H364.578C364.06 135.884 363.633 136.307 363.633 136.827V139.346H369.854V116.587C369.854 116.352 370.046 116.161 370.282 116.161C370.517 116.161 370.713 115.97 370.713 115.735V107.277C370.713 106.758 371.134 106.335 371.659 106.335H387.27V105.393C387.27 104.873 387.694 104.451 388.216 104.451H392.488C392.905 104.451 393.274 104.18 393.394 103.783L395.59 96.6288C395.709 96.2317 396.079 95.961 396.496 95.961H450.007C450.525 95.961 450.952 96.3833 450.952 96.9031V139.35V189.187H215.152V139.249V120.919C215.152 120.724 215.214 120.532 215.326 120.373L224.549 107.339C224.643 107.205 224.766 107.104 224.9 107.039V106.703H252.842C253.259 106.703 253.629 106.974 253.748 107.371L255.944 114.526C256.064 114.923 256.433 115.194 256.85 115.194H261.122C261.64 115.194 262.068 115.616 262.068 116.136V139.245H270.591V138.512C270.591 137.993 271.015 137.57 271.537 137.57H279.349V132.647C279.349 132.387 279.563 132.174 279.824 132.174H280.77V121.326C280.509 121.326 280.295 121.113 280.295 120.854V119.911C280.295 119.652 280.509 119.439 280.77 119.439V118.496C280.509 118.496 280.295 118.283 280.295 118.024V117.081C280.295 116.822 280.509 116.609 280.77 116.609V106.703H280.295C280.034 106.703 279.82 106.491 279.82 106.231V102.928C279.82 102.668 280.034 102.455 280.295 102.455H281.241V101.513H280.766C280.505 101.513 280.292 101.3 280.292 101.04V100.098C280.292 99.8378 280.505 99.6248 280.766 99.6248H281.241V99.1519H280.766C280.505 99.1519 280.292 98.939 280.292 98.6791V97.7369C280.292 97.477 280.505 97.2641 280.766 97.2641H281.241V93.4919H280.766C280.505 93.4919 280.292 93.2789 280.292 93.019V92.0769C280.292 91.817 280.505 91.604 280.766 91.604H281.241V89.2469H280.766C280.505 89.2469 280.292 89.0339 280.292 88.774V88.3011C280.292 88.0412 280.505 87.8282 280.766 87.8282H281.241V83.5796C280.418 83.5327 279.73 82.9118 279.618 82.0852C279.281 79.6306 279.266 77.1471 279.574 74.6925L279.61 74.3748C279.676 73.8767 279.926 73.4471 280.292 73.1511V71.3138C280.292 71.0539 280.505 70.8409 280.766 70.8409H281.241V66.123Z",
    fill: "url(#paint3_linear_5001_64747)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.363 138.82H379.742V165.27H368.363V138.82Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.056 138.203H380.053V138.512H368.056V138.203Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.443 138.82H379.67V140.051H368.443V138.82Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.443 153.889H379.67V155.12H368.443V153.889Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.824 138.82H378.514V152.045H373.824V138.82Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.514 161.271H378.514V165.271H374.514V161.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.594 161.271H373.594V165.271H369.594V161.271Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.594 162.809H371.748V165.269H369.594V162.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.899 156.043H378.514V156.966H376.899V156.043Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.594 156.043H376.209V156.966H374.594V156.043Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.594 156.043H373.594V159.426H369.594V156.043Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.134 156.043H373.594V159.426H371.134V156.043Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.596 156.043H371.133V159.426H369.596V156.043Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.824 140.666H378.514V143.743H373.824V140.666Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.824 144.973H378.514V148.049H373.824V144.973Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.824 148.969H378.514V152.046H373.824V148.969Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.901 140.666H374.824V143.743H373.901V140.666Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.901 144.973H374.824V148.049H373.901V144.973Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.901 148.969H374.824V152.046H373.901V148.969Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.443 152.66H379.67V152.969H368.443V152.66Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.597 140.666H371.596V143.743H369.597V140.666Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.597 144.973H371.596V148.049H369.597V144.973Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.597 148.969H371.596V152.046H369.597V148.969Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.595 140.666H370.209V143.743H369.595V140.666Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.595 144.973H370.209V148.049H369.595V144.973Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.595 148.969H370.209V152.046H369.595V148.969Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.363 140.666H377.361V143.743H375.363V140.666Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.363 144.973H377.361V148.049H375.363V144.973Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.363 148.969H377.361V152.046H375.363V148.969Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.739 142.637H320.256V165.704H262.739V142.637Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.739 158.633H320.256V165.707H262.739V158.633Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.257 147.252H317.488V150.329H316.257V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.05 144.328H321.949V145.251H261.05V144.328Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.257 153.709H317.488V156.786H316.257V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.951 160.168H319.027V165.705H315.951V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.568 160.168H313.182V165.705H308.568V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.802 160.168H306.416V165.705H301.802V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.035 160.168H299.648V165.705H295.035V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.496 161.243C293.496 160.139 292.601 159.244 291.497 159.244C290.393 159.244 289.499 160.139 289.499 161.243V165.704H293.498V161.243H293.496Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.347 160.168H287.961V165.705H283.347V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.581 160.168H281.195V165.705H276.581V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.507 160.168H274.121V165.705H269.507V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.279 160.168H267.047V165.705H264.279V160.168Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.951 161.094H319.027V165.708H315.951V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.568 161.094H313.182V165.708H308.568V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.802 161.094H306.416V165.708H301.802V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.035 161.094H299.648V165.708H295.035V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.496 162.167C293.496 161.063 292.601 160.168 291.497 160.168C290.393 160.168 289.499 161.063 289.499 162.167V165.705H293.498V162.167H293.496Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.347 161.094H287.961V165.708H283.347V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.581 161.094H281.195V165.708H276.581V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.507 161.094H274.121V165.708H269.507V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.279 161.094H267.047V165.708H264.279V161.094Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.029 147.252H312.26V150.329H311.029V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.029 153.709H312.26V156.786H311.029V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.644 147.252H308.875V150.329H307.644V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.648 153.709H308.879V156.786H307.648V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.263 147.252H305.494V150.329H304.263V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.263 153.709H305.494V156.786H304.263V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.185 147.252H302.416V150.329H301.185V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.185 153.709H302.416V156.786H301.185V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.493 147.252H298.725V150.329H297.493V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.495 153.709H298.727V156.786H297.495V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.421 147.252H295.652V150.329H294.421V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.421 153.709H295.652V156.786H294.421V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73 147.252H291.961V150.329H290.73V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73 153.709H291.961V156.786H290.73V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.036 147.252H288.268V150.329H287.036V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.036 153.709H288.268V156.786H287.036V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.656 147.252H284.887V150.329H283.656V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.656 153.709H284.887V156.786H283.656V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.577 147.252H281.809V150.329H280.577V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.577 153.709H281.809V156.786H280.577V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.888 147.252H278.119V150.329H276.888V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.888 153.709H278.119V156.786H276.888V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.503 147.252H274.734V150.329H273.503V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.503 153.709H274.734V156.786H273.503V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.429 147.252H271.66V150.329H270.429V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.429 153.709H271.66V156.786H270.429V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.505 147.252H266.736V150.329H265.505V147.252Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.509 153.709H266.74V156.786H265.509V153.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.818 142.637H321.178V144.482H261.818V142.637Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.028 143.254H320.256V143.868H315.028V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.649 143.254H312.877V143.868H307.649V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.266 143.254H305.494V143.868H300.266V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.881 143.254H298.109V143.868H292.881V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5 143.254H290.729V143.868H285.5V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.121 143.254H283.35V143.868H278.121V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.738 143.254H275.967V143.868H270.738V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.356 143.254H268.584V143.868H263.356V143.254Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.378 141.254L289.68 141.315L289.63 141.562H289.378V141.254ZM288.117 141.254H287.808V140.946H288.117V141.254ZM288.117 142.791V143.1H287.808V142.791H288.117ZM294.268 142.791H294.576V143.1H294.268V142.791ZM294.268 141.254V140.946H294.576V141.254H294.268ZM293.006 141.254V141.562H292.754L292.705 141.315L293.006 141.254ZM289.378 141.562H288.117V140.948H289.378V141.562ZM288.423 141.254V142.791H287.808V141.254H288.423ZM288.117 142.483H294.268V143.097H288.117V142.483ZM293.959 142.791V141.254H294.574V142.791H293.959ZM294.268 141.562H293.006V140.948H294.268V141.562ZM292.705 141.315C292.592 140.755 292.093 140.331 291.499 140.331V139.717C292.392 139.717 293.136 140.35 293.307 141.193L292.705 141.315ZM291.499 140.331H290.885V139.717H291.499V140.331ZM290.885 140.331C290.292 140.331 289.793 140.755 289.68 141.315L289.077 141.193C289.249 140.35 289.993 139.717 290.885 139.717V140.331Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.376 141.253H288.114V142.79H294.266V141.253H293.004C292.863 140.551 292.241 140.021 291.497 140.021H290.883C290.139 140.021 289.517 140.549 289.376 141.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12 151.119H271.033V165.267H246.12V151.119Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12 160.344H271.033V165.264H246.12V160.344Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.496 162.191H267.65V165.268H265.496V162.191Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.498 162.191H263.652V165.268H261.498V162.191Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.885 162.191H259.039V165.268H256.885V162.191Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.885 162.191H255.039V165.268H252.885V162.191Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 162.191H250.732V165.268H248.578V162.191Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.496 154.193H267.65V158.807H265.496V154.193Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.498 154.193H263.652V158.807H261.498V154.193Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.885 154.193H259.039V158.807H256.885V154.193Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.885 154.193H255.039V158.807H252.885V154.193Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.653 158.504H266.109V160.349H251.653V158.504Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.578 154.193H250.732V158.807H248.578V154.193Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.576 144.988L270.549 151.121H246.601L258.574 144.988H258.576Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.957 152.043L272.727 151.274L258.426 143.738L244.586 151.274L245.201 152.043L258.426 144.969L271.959 152.043H271.957Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.658 161.63H265.037V162.654H268.113V161.63H267.492C267.442 161.168 267.049 160.811 266.576 160.811C266.103 160.811 265.71 161.168 265.66 161.63H265.658Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.656 161.628L265.96 161.661L265.929 161.934H265.656V161.626V161.628ZM265.035 161.628H264.726V161.32H265.035V161.628ZM265.035 162.652V162.96H264.726V162.652H265.035ZM268.112 162.652H268.42V162.96H268.112V162.652ZM268.112 161.628V161.32H268.42V161.628H268.112ZM267.49 161.628V161.936H267.217L267.186 161.663L267.49 161.63V161.628ZM265.656 161.936H265.035V161.322H265.656V161.936ZM265.343 161.628V162.652H264.729V161.628H265.343ZM265.035 162.346H268.112V162.96H265.035V162.346ZM267.803 162.652V161.628H268.418V162.652H267.803ZM268.112 161.936H267.49V161.322H268.112V161.936ZM267.184 161.661C267.151 161.353 266.89 161.115 266.572 161.115V160.5C267.205 160.5 267.725 160.978 267.796 161.595L267.184 161.663V161.661ZM266.572 161.115C266.254 161.115 265.993 161.355 265.96 161.661L265.348 161.593C265.418 160.978 265.939 160.498 266.572 160.498V161.112V161.115Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.656 161.63H261.035V162.654H264.111V161.63H263.49C263.44 161.168 263.047 160.811 262.574 160.811C262.101 160.811 261.708 161.168 261.658 161.63H261.656Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.658 161.628L261.962 161.661L261.931 161.934H261.658V161.626V161.628ZM261.037 161.628H260.728V161.32H261.037V161.628ZM261.037 162.652V162.96H260.728V162.652H261.037ZM264.113 162.652H264.422V162.96H264.113V162.652ZM264.113 161.628V161.32H264.422V161.628H264.113ZM263.492 161.628V161.936H263.219L263.188 161.663L263.492 161.63V161.628ZM261.658 161.936H261.037V161.322H261.658V161.936ZM261.345 161.628V162.652H260.731V161.628H261.345ZM261.037 162.346H264.113V162.96H261.037V162.346ZM263.805 162.652V161.628H264.42V162.652H263.805ZM264.113 161.936H263.492V161.322H264.113V161.936ZM263.188 161.661C263.155 161.353 262.894 161.115 262.576 161.115V160.5C263.21 160.5 263.73 160.978 263.8 161.595L263.188 161.663V161.661ZM262.576 161.115C262.258 161.115 261.997 161.355 261.964 161.661L261.352 161.593C261.423 160.978 261.943 160.498 262.576 160.498V161.112V161.115Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.045 161.63H256.423V162.654H259.5V161.63H258.879C258.829 161.168 258.436 160.811 257.963 160.811C257.49 160.811 257.097 161.168 257.047 161.63H257.045Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.047 161.628L257.351 161.661L257.32 161.934H257.047V161.626V161.628ZM256.426 161.628H256.117V161.32H256.426V161.628ZM256.426 162.652V162.96H256.117V162.652H256.426ZM259.5 162.652H259.809V162.96H259.5V162.652ZM259.5 161.628V161.32H259.809V161.628H259.5ZM258.879 161.628V161.936H258.606L258.575 161.663L258.879 161.63V161.628ZM257.047 161.936H256.426V161.322H257.047V161.936ZM256.732 161.628V162.652H256.117V161.628H256.732ZM256.426 162.346H259.503V162.96H256.426V162.346ZM259.194 162.652V161.628H259.809V162.652H259.194ZM259.5 161.936H258.879V161.322H259.5V161.936ZM258.575 161.661C258.542 161.353 258.281 161.115 257.963 161.115V160.5C258.596 160.5 259.117 160.978 259.187 161.595L258.575 161.663V161.661ZM257.963 161.115C257.645 161.115 257.384 161.355 257.351 161.661L256.739 161.593C256.81 160.978 257.33 160.498 257.963 160.498V161.112V161.115Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.047 161.63H252.425V162.654H255.502V161.63H254.881C254.831 161.168 254.438 160.811 253.965 160.811C253.492 160.811 253.098 161.168 253.049 161.63H253.047Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.045 161.628L253.349 161.661L253.318 161.934H253.045V161.626V161.628ZM252.423 161.628H252.115V161.32H252.423V161.628ZM252.423 162.652V162.96H252.115V162.652H252.423ZM255.5 162.652H255.809V162.96H255.5V162.652ZM255.5 161.628V161.32H255.809V161.628H255.5ZM254.879 161.628V161.936H254.606L254.575 161.663L254.879 161.63V161.628ZM253.045 161.936H252.423V161.322H253.045V161.936ZM252.732 161.628V162.652H252.117V161.628H252.732ZM252.423 162.346H255.5V162.96H252.423V162.346ZM255.192 162.652V161.628H255.806V162.652H255.192ZM255.5 161.936H254.879V161.322H255.5V161.936ZM254.573 161.661C254.54 161.353 254.278 161.115 253.961 161.115V160.5C254.594 160.5 255.114 160.978 255.185 161.595L254.573 161.663V161.661ZM253.961 161.115C253.643 161.115 253.382 161.355 253.349 161.661L252.737 161.593C252.807 160.978 253.327 160.498 253.961 160.498V161.112V161.115Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.74 161.63H248.119V162.654H251.195V161.63H250.574C250.524 161.168 250.131 160.811 249.658 160.811C249.185 160.811 248.792 161.168 248.742 161.63H248.74Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.741 161.628L249.044 161.661L249.014 161.934H248.741V161.626V161.628ZM248.119 161.628H247.811V161.32H248.119V161.628ZM248.119 162.652V162.96H247.811V162.652H248.119ZM251.194 162.652H251.502V162.96H251.194V162.652ZM251.194 161.628V161.32H251.502V161.628H251.194ZM250.574 161.628V161.936H250.301L250.271 161.663L250.574 161.63V161.628ZM248.741 161.936H248.119V161.322H248.741V161.936ZM248.428 161.628V162.652H247.813V161.628H248.428ZM248.119 162.346H251.196V162.96H248.119V162.346ZM250.888 162.652V161.628H251.502V162.652H250.888ZM251.194 161.936H250.572V161.322H251.194V161.936ZM250.268 161.661C250.235 161.353 249.974 161.115 249.656 161.115V160.5C250.29 160.5 250.81 160.978 250.881 161.595L250.268 161.663V161.661ZM249.656 161.115C249.339 161.115 249.077 161.355 249.044 161.661L248.432 161.593C248.503 160.978 249.023 160.498 249.656 160.498V161.112V161.115Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.187 152.809C265.187 152.837 265.203 152.882 265.26 152.936C265.318 152.993 265.41 153.049 265.54 153.101C265.794 153.205 266.161 153.27 266.571 153.27C266.98 153.27 267.345 153.205 267.602 153.101C267.731 153.049 267.823 152.993 267.882 152.936C267.941 152.88 267.955 152.837 267.955 152.809C267.955 152.781 267.939 152.736 267.882 152.682C267.823 152.625 267.731 152.569 267.602 152.517C267.348 152.414 266.98 152.348 266.571 152.348C266.161 152.348 265.796 152.414 265.54 152.517C265.41 152.569 265.318 152.625 265.26 152.682C265.201 152.738 265.187 152.781 265.187 152.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.191 152.809C261.191 152.837 261.207 152.882 261.264 152.936C261.322 152.993 261.414 153.049 261.544 153.101C261.798 153.205 262.165 153.27 262.575 153.27C262.984 153.27 263.349 153.205 263.606 153.101C263.735 153.049 263.827 152.993 263.886 152.936C263.945 152.88 263.959 152.837 263.959 152.809C263.959 152.781 263.943 152.736 263.886 152.682C263.827 152.625 263.735 152.569 263.606 152.517C263.352 152.414 262.984 152.348 262.575 152.348C262.165 152.348 261.8 152.414 261.544 152.517C261.414 152.569 261.322 152.625 261.264 152.682C261.205 152.738 261.191 152.781 261.191 152.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.577 152.809C256.577 152.837 256.594 152.882 256.65 152.936C256.709 152.993 256.801 153.049 256.93 153.101C257.185 153.205 257.552 153.27 257.961 153.27C258.371 153.27 258.736 153.205 258.993 153.101C259.122 153.049 259.214 152.993 259.273 152.936C259.332 152.88 259.346 152.837 259.346 152.809C259.346 152.781 259.329 152.736 259.273 152.682C259.214 152.625 259.122 152.569 258.993 152.517C258.738 152.414 258.371 152.348 257.961 152.348C257.552 152.348 257.187 152.414 256.93 152.517C256.801 152.569 256.709 152.625 256.65 152.682C256.591 152.738 256.577 152.781 256.577 152.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.579 152.809C252.579 152.837 252.596 152.882 252.652 152.936C252.711 152.993 252.803 153.049 252.932 153.101C253.187 153.205 253.554 153.27 253.963 153.27C254.373 153.27 254.738 153.205 254.995 153.101C255.124 153.049 255.216 152.993 255.275 152.936C255.334 152.88 255.348 152.837 255.348 152.809C255.348 152.781 255.331 152.736 255.275 152.682C255.216 152.625 255.124 152.569 254.995 152.517C254.74 152.414 254.373 152.348 253.963 152.348C253.554 152.348 253.189 152.414 252.932 152.517C252.803 152.569 252.711 152.625 252.652 152.682C252.593 152.738 252.579 152.781 252.579 152.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.273 152.809C248.273 152.837 248.289 152.882 248.346 152.936C248.404 152.993 248.496 153.049 248.626 153.101C248.88 153.205 249.247 153.27 249.657 153.27C250.066 153.27 250.431 153.205 250.688 153.101C250.817 153.049 250.909 152.993 250.968 152.936C251.027 152.88 251.041 152.837 251.041 152.809C251.041 152.781 251.025 152.736 250.968 152.682C250.909 152.625 250.817 152.569 250.688 152.517C250.434 152.414 250.066 152.348 249.657 152.348C249.247 152.348 248.882 152.414 248.626 152.517C248.496 152.569 248.404 152.625 248.346 152.682C248.287 152.738 248.273 152.781 248.273 152.809Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.424 146.965L262.576 148.963H254.579L258.424 146.965Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.207 166.182L181.715 167.793C179.155 168.077 176.703 166.705 175.607 164.376L174.892 162.859C174.652 162.35 174.543 161.79 174.572 161.23L174.652 159.722C174.814 156.578 179.071 155.74 180.413 158.585L181.157 156.169C182.127 153.015 186.582 152.996 187.581 156.142C187.983 151.656 193.882 150.294 196.209 154.15L196.815 153.192C198.468 150.577 202.051 150.025 204.419 152.017C206.455 153.733 206.828 156.729 205.277 158.893L203.699 161.092C205.885 161.763 205.619 164.936 203.355 165.234L196.209 166.179L196.207 166.182Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.242381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.632 166.18L182.698 167.734C180.153 168.039 177.691 166.696 176.571 164.389L176.072 163.359C175.844 162.891 175.735 162.375 175.761 161.856L175.819 160.625C175.953 157.733 179.855 156.928 181.12 159.529L181.768 157.43C182.657 154.526 186.753 154.485 187.701 157.369C188.045 153.293 193.39 152.01 195.549 155.486L195.634 155.627L196.17 154.79C197.692 152.418 200.945 151.911 203.119 153.707C205.029 155.287 205.38 158.084 203.921 160.089L202.576 161.936C204.479 162.52 204.207 165.295 202.227 165.499L195.637 166.178L195.632 166.18Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.187 165.971L234.759 161.982C237.216 160.688 238.707 158.098 238.594 155.325L238.484 152.732C238.458 152.06 238.264 151.409 237.919 150.83L237.005 149.279C235.091 146.043 230.125 147.508 230.278 151.264L228.157 149.12C225.384 146.318 220.657 148.764 221.343 152.645C218.44 148.118 211.439 149.942 211.109 155.311L209.94 154.633C206.741 152.781 202.646 154.176 201.242 157.594C200.035 160.538 201.3 163.916 204.139 165.345L207.022 166.801H223.838C225.008 166.801 226.157 166.518 227.19 165.973L227.187 165.971Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.289433
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56 165.971L364.132 161.982C366.589 160.688 368.08 158.098 367.967 155.325L367.857 152.732C367.831 152.06 367.637 151.409 367.292 150.83L366.378 149.279C364.465 146.043 359.498 147.508 359.651 151.264L357.53 149.12C354.757 146.318 350.03 148.764 350.716 152.645C347.813 148.118 340.812 149.942 340.482 155.311L339.313 154.633C336.115 152.781 332.019 154.176 330.615 157.594C329.408 160.538 330.673 163.916 333.513 165.345L336.395 166.801H353.211C354.381 166.801 355.53 166.518 356.563 165.973L356.56 165.971Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.289433
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.471 164.608L234.916 162.64C236.67 161.23 237.663 159.08 237.596 156.831L237.51 153.919C237.495 153.3 237.321 152.695 237.006 152.16L236.265 150.889C234.526 147.905 229.953 149.207 230.048 152.66L228.207 150.796C225.657 148.217 221.301 150.437 221.892 154.018C219.272 149.893 212.908 151.491 212.546 156.365L212.532 156.562L211.498 155.974C208.578 154.304 204.853 155.569 203.55 158.672C202.404 161.401 203.576 164.553 206.231 165.87L208.676 167.08H221.889L228.919 166.136C230.216 165.963 231.446 165.436 232.468 164.614L232.471 164.608Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.846 164.608L364.291 162.64C366.045 161.23 367.038 159.08 366.971 156.831L366.885 153.919C366.87 153.3 366.696 152.695 366.381 152.16L365.64 150.889C363.901 147.905 359.328 149.207 359.423 152.66L357.582 150.796C355.032 148.217 350.676 150.437 351.267 154.018C348.647 149.893 342.283 151.491 341.921 156.365L341.907 156.562L340.873 155.974C337.953 154.304 334.228 155.569 332.925 158.672C331.779 161.401 332.951 164.553 335.606 165.87L338.051 167.08H351.264L358.294 166.136C359.591 165.963 360.821 165.436 361.843 164.614L361.846 164.608Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.574 160.891C262.521 159.785 262.312 158.123 263.058 156.79L267.291 149.213C267.703 148.476 268.762 148.476 269.174 149.213L273.529 157.014C274.209 158.229 274.061 159.74 273.159 160.802C272.526 161.548 271.596 161.976 270.615 161.976H266.102C265.146 161.976 264.233 161.583 263.574 160.891Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.827 161.047C262.812 160.1 262.612 158.566 263.349 157.391L266.88 151.791C267.36 151.026 268.478 151.026 268.959 151.791L272.991 158.189C273.443 158.909 273.349 159.846 272.76 160.463C271.925 161.334 270.771 161.826 269.564 161.826H265.795C265.063 161.826 264.359 161.548 263.822 161.049L263.827 161.047Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.23 154.131V165.51",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.535 155.061L268.381 157.215",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.922 157.516L268.076 159.67",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.231 155.061L268.385 157.215",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58 165.338C255.148 164.051 255.353 161.753 256.985 160.736L259.694 159.051C260.113 158.792 260.645 158.801 261.05 159.079L263.456 160.72C265.012 161.784 265.219 163.999 263.887 165.331C263.868 165.348 263.847 165.357 263.823 165.357H256.631C256.613 165.357 256.594 165.35 256.58 165.336V165.338Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58 165.336C256.594 165.35 256.613 165.357 256.631 165.357H263.823C263.847 165.357 263.868 165.348 263.887 165.331C265.219 163.999 265.012 161.784 263.456 160.72L261.05 159.079C260.645 158.801 260.113 158.792 259.694 159.051L256.985 160.736C255.353 161.753 255.148 164.051 256.58 165.338V165.336ZM256.58 165.336L256.476 165.451",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.179 165.14C255.244 164.017 255.546 162.322 256.81 161.588L259.842 159.829C260.176 159.636 260.593 159.641 260.922 159.841L263.001 161.11C264.479 162.011 264.585 164.118 263.203 165.163C263.173 165.189 263.133 165.201 263.09 165.201H256.32C256.264 165.201 256.216 165.178 256.179 165.135V165.14Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.926 162.746V165.206",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.924 162.129L259.925 163.974",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.389 163.053L259.926 164.745",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9217 166.607L31.4298 168.219C28.8702 168.503 26.4174 167.131 25.3218 164.802L24.6068 163.284C24.3668 162.775 24.2577 162.215 24.2868 161.656L24.3668 160.148C24.5292 157.004 28.7854 156.166 30.1282 159.011L30.8723 156.595C31.8418 153.441 36.2968 153.422 37.2954 156.568C37.6977 152.082 43.5973 150.719 45.9242 154.576L46.5301 153.618C48.1832 151.003 51.7655 150.45 54.1336 152.443C56.1696 154.159 56.5428 157.155 54.9916 159.319L53.4137 161.517C55.6 162.189 55.3334 165.362 53.0695 165.66L45.9242 166.605L45.9217 166.607Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.242381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3465 166.606L32.4131 168.159C29.8681 168.465 27.4055 167.122 26.2857 164.815L25.7864 163.784C25.5586 163.317 25.4495 162.8 25.4762 162.282L25.5343 161.05C25.6676 158.159 29.57 157.354 30.8352 159.955L31.4824 157.856C32.3719 154.952 36.4681 154.911 37.4158 157.795C37.76 153.718 43.1046 152.436 45.2642 155.912L45.349 156.052L45.8846 155.216C47.4068 152.843 50.6596 152.337 52.8337 154.133C54.7437 155.713 55.0951 158.51 53.636 160.515L52.2908 162.362C54.1935 162.946 53.922 165.721 51.9418 165.925L45.3514 166.603L45.3465 166.606Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9039 166.391L84.4754 162.402C86.9327 161.108 88.4233 158.518 88.3104 155.745L88.2004 153.152C88.1743 152.48 87.9804 151.829 87.636 151.25L86.7214 149.699C84.8083 146.463 79.8416 147.928 79.995 151.684L77.8734 149.54C75.1007 146.738 70.3742 149.184 71.0602 153.065C68.1572 148.538 61.1558 150.362 60.8258 155.731L59.6565 155.053C56.4583 153.201 52.3628 154.596 50.959 158.014C49.7521 160.958 51.0169 164.336 53.8563 165.765L56.739 167.221H73.5551C74.7244 167.221 75.8734 166.938 76.9067 166.393L76.9039 166.391Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.289433
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.277 166.391L213.848 162.402C216.306 161.108 217.796 158.518 217.683 155.745L217.573 153.152C217.547 152.48 217.353 151.829 217.009 151.25L216.094 149.699C214.181 146.463 209.215 147.928 209.368 151.684L207.246 149.54C204.474 146.738 199.747 149.184 200.433 153.065C197.53 148.538 190.529 150.362 190.199 155.731L189.03 155.053C185.831 153.201 181.736 154.596 180.332 158.014C179.125 160.958 180.39 164.336 183.229 165.765L186.112 167.221H202.928C204.097 167.221 205.246 166.938 206.28 166.393L206.277 166.391Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.289433
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1893 165.028L84.6351 163.06C86.389 161.65 87.3818 159.5 87.3152 157.251L87.2284 154.339C87.2139 153.72 87.0402 153.115 86.7248 152.579L85.9838 151.309C84.2443 148.325 79.6713 149.627 79.7668 153.08L77.9259 151.216C75.376 148.637 71.0201 150.857 71.6106 154.438C68.9912 150.313 62.6265 151.911 62.2648 156.785L62.2503 156.982L61.217 156.394C58.2966 154.724 54.5716 155.989 53.2692 159.092C52.123 161.821 53.2952 164.973 55.9493 166.29L58.395 167.5H71.6077L78.638 166.556C79.9347 166.383 81.1648 165.856 82.1865 165.034L82.1893 165.028Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.562 165.028L214.008 163.06C215.762 161.65 216.755 159.5 216.688 157.251L216.601 154.339C216.587 153.72 216.413 153.115 216.098 152.579L215.357 151.309C213.617 148.325 209.044 149.627 209.14 153.08L207.299 151.216C204.749 148.637 200.393 150.857 200.984 154.438C198.364 150.313 192 151.911 191.638 156.785L191.623 156.982L190.59 156.394C187.67 154.724 183.945 155.989 182.642 159.092C181.496 161.821 182.668 164.973 185.322 166.29L187.768 167.5H200.981L208.011 166.556C209.308 166.383 210.538 165.856 211.56 165.034L211.562 165.028Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29 161.311C112.238 160.205 112.029 158.543 112.775 157.21L117.007 149.633C117.419 148.896 118.479 148.896 118.891 149.633L123.246 157.434C123.926 158.649 123.778 160.16 122.876 161.222C122.243 161.968 121.313 162.396 120.331 162.396H115.819C114.863 162.396 113.949 162.003 113.29 161.311Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.544 161.467C112.529 160.52 112.329 158.985 113.066 157.811L116.597 152.211C117.077 151.445 118.195 151.445 118.675 152.211L122.708 158.609C123.16 159.329 123.066 160.266 122.477 160.883C121.641 161.754 120.488 162.246 119.28 162.246H115.512C114.779 162.246 114.076 161.968 113.539 161.469L113.544 161.467Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.945 154.557V165.936",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.254 155.479L118.1 157.632",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.639 157.938L117.793 160.091",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.948 155.479L118.102 157.632",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.296 165.762C104.865 164.475 105.07 162.177 106.701 161.16L109.411 159.475C109.83 159.216 110.362 159.225 110.767 159.503L113.173 161.144C114.729 162.208 114.936 164.423 113.603 165.755C113.585 165.772 113.563 165.781 113.54 165.781H106.348C106.329 165.781 106.311 165.774 106.296 165.76V165.762Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.296 165.76C106.311 165.774 106.329 165.781 106.348 165.781H113.54C113.563 165.781 113.585 165.772 113.603 165.755C114.936 164.423 114.729 162.208 113.173 161.144L110.767 159.503C110.362 159.225 109.83 159.216 109.411 159.475L106.701 161.16C105.07 162.177 104.865 164.475 106.296 165.762V165.76ZM106.296 165.76L106.193 165.875",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.896 165.564C104.961 164.441 105.262 162.746 106.526 162.011L109.558 160.253C109.893 160.06 110.309 160.065 110.639 160.265L112.718 161.534C114.196 162.435 114.302 164.542 112.92 165.587C112.889 165.613 112.849 165.625 112.807 165.625H106.037C105.98 165.625 105.933 165.601 105.896 165.559V165.564Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.643 163.164V165.624",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.641 162.549L109.642 164.394",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.105 163.473L109.643 165.165",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.228 119.568H361.762V165.703H352.228V119.568Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.921 122.029H352.227V165.704H347.921V122.029Z",
    fill: "#F5D7CA",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.691 119.568H359.305V165.703H354.691V119.568Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.388 119.568H347.922V165.703H338.388V119.568Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.849 119.568H345.463V165.703H340.849V119.568Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.846 119.568H343V165.703H340.846V119.568Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.69 119.568H356.844V165.703H354.69V119.568Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.691 112.109H357.844V119.645H357.691V112.109Z",
    stroke: "#615E66",
    strokeWidth: 0.117703
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.845 117.033H355.998V119.649H355.845V117.033Z",
    stroke: "#615E66",
    strokeWidth: 0.117703
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.938 126.045H291.084V142.597H261.938V126.045Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.938 136.836H291.084V142.592H261.938V136.836Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.605 138.994H287.125V142.594H284.605V138.994Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.925 138.994H282.445V142.594H279.925V138.994Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.529 138.994H277.049V142.594H274.529V138.994Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.851 138.994H272.371V142.594H269.851V138.994Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.816 138.994H267.336V142.594H264.816V138.994Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.605 129.643H287.125V135.04H284.605V129.643Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.925 129.643H282.445V135.04H279.925V129.643Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.529 129.643H277.049V135.04H274.529V129.643Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.851 129.643H272.371V135.04H269.851V129.643Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41 134.682H285.322V136.841H268.41V134.682Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.816 129.643H267.336V135.04H264.816V129.643Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.509 118.869L290.516 126.043H262.499L276.506 118.869H276.509Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.164 127.122L293.064 126.222L276.334 117.406L260.143 126.222L260.862 127.122L276.334 118.847L292.167 127.122H292.164Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.794 138.337H284.066V139.535H287.666V138.337H286.939C286.881 137.798 286.421 137.379 285.868 137.379C285.314 137.379 284.854 137.798 284.796 138.337H284.794Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.794 138.338L285.149 138.376L285.114 138.696H284.794V138.335V138.338ZM284.067 138.338H283.706V137.977H284.067V138.338ZM284.067 139.536V139.896H283.706V139.536H284.067ZM287.667 139.536H288.027V139.896H287.667V139.536ZM287.667 138.338V137.977H288.027V138.338H287.667ZM286.939 138.338V138.698H286.62L286.584 138.379L286.939 138.34V138.338ZM284.794 138.698H284.067V137.98H284.794V138.698ZM284.428 138.338V139.536H283.709V138.338H284.428ZM284.067 139.178H287.667V139.896H284.067V139.178ZM287.306 139.536V138.338H288.025V139.536H287.306ZM287.667 138.698H286.939V137.98H287.667V138.698ZM286.581 138.376C286.543 138.015 286.237 137.737 285.865 137.737V137.018C286.606 137.018 287.215 137.577 287.297 138.299L286.581 138.379V138.376ZM285.865 137.737C285.494 137.737 285.188 138.018 285.149 138.376L284.433 138.296C284.516 137.577 285.125 137.016 285.865 137.016V137.734V137.737Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.114 138.337H279.387V139.535H282.986V138.337H282.259C282.201 137.798 281.741 137.379 281.188 137.379C280.634 137.379 280.174 137.798 280.117 138.337H280.114Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.112 138.338L280.468 138.376L280.432 138.696H280.112V138.335V138.338ZM279.385 138.338H279.025V137.977H279.385V138.338ZM279.385 139.536V139.896H279.025V139.536H279.385ZM282.985 139.536H283.346V139.896H282.985V139.536ZM282.985 138.338V137.977H283.346V138.338H282.985ZM282.258 138.338V138.698H281.938L281.903 138.379L282.258 138.34V138.338ZM280.112 138.698H279.385V137.98H280.112V138.698ZM279.746 138.338V139.536H279.027V138.338H279.746ZM279.385 139.178H282.985V139.896H279.385V139.178ZM282.624 139.536V138.338H283.343V139.536H282.624ZM282.985 138.698H282.258V137.98H282.985V138.698ZM281.903 138.376C281.864 138.015 281.558 137.737 281.187 137.737V137.018C281.927 137.018 282.536 137.577 282.619 138.299L281.903 138.379V138.376ZM281.187 137.737C280.815 137.737 280.509 138.018 280.47 138.376L279.754 138.296C279.837 137.577 280.446 137.016 281.187 137.016V137.734V137.737Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.719 138.337H273.992V139.535H277.592V138.337H276.865C276.807 137.798 276.347 137.379 275.793 137.379C275.24 137.379 274.78 137.798 274.722 138.337H274.719Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.719 138.338L275.074 138.376L275.038 138.696H274.719V138.335V138.338ZM273.992 138.338H273.631V137.977H273.992V138.338ZM273.992 139.536V139.896H273.631V139.536H273.992ZM277.588 139.536H277.949V139.896H277.588V139.536ZM277.588 138.338V137.977H277.949V138.338H277.588ZM276.861 138.338V138.698H276.542L276.506 138.379L276.861 138.34V138.338ZM274.719 138.698H273.992V137.98H274.719V138.698ZM274.35 138.338V139.536H273.631V138.338H274.35ZM273.992 139.178H277.591V139.896H273.992V139.178ZM277.23 139.536V138.338H277.949V139.536H277.23ZM277.588 138.698H276.861V137.98H277.588V138.698ZM276.506 138.376C276.468 138.015 276.162 137.737 275.79 137.737V137.018C276.531 137.018 277.14 137.577 277.222 138.299L276.506 138.379V138.376ZM275.79 137.737C275.418 137.737 275.113 138.018 275.074 138.376L274.358 138.296C274.441 137.577 275.049 137.016 275.79 137.016V137.734V137.737Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.04 138.337H269.313V139.535H272.912V138.337H272.185C272.127 137.798 271.667 137.379 271.114 137.379C270.56 137.379 270.1 137.798 270.042 138.337H270.04Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.038 138.338L270.394 138.376L270.358 138.696H270.038V138.335V138.338ZM269.311 138.338H268.95V137.977H269.311V138.338ZM269.311 139.536V139.896H268.95V139.536H269.311ZM272.911 139.536H273.271V139.896H272.911V139.536ZM272.911 138.338V137.977H273.271V138.338H272.911ZM272.184 138.338V138.698H271.864L271.828 138.379L272.184 138.34V138.338ZM270.038 138.698H269.311V137.98H270.038V138.698ZM269.672 138.338V139.536H268.953V138.338H269.672ZM269.311 139.178H272.911V139.896H269.311V139.178ZM272.55 139.536V138.338H273.269V139.536H272.55ZM272.911 138.698H272.184V137.98H272.911V138.698ZM271.826 138.376C271.787 138.015 271.481 137.737 271.11 137.737V137.018C271.85 137.018 272.459 137.577 272.542 138.299L271.826 138.379V138.376ZM271.11 137.737C270.738 137.737 270.432 138.018 270.394 138.376L269.677 138.296C269.76 137.577 270.369 137.016 271.11 137.016V137.734V137.737Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.005 138.337H264.277V139.535H267.877V138.337H267.15C267.092 137.798 266.632 137.379 266.079 137.379C265.525 137.379 265.065 137.798 265.007 138.337H265.005Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.002 138.338L265.357 138.376L265.321 138.696H265.002V138.335V138.338ZM264.275 138.338H263.914V137.977H264.275V138.338ZM264.275 139.536V139.896H263.914V139.536H264.275ZM267.872 139.536H268.232V139.896H267.872V139.536ZM267.872 138.338V137.977H268.232V138.338H267.872ZM267.147 138.338V138.698H266.828L266.792 138.379L267.147 138.34V138.338ZM265.002 138.698H264.275V137.98H265.002V138.698ZM264.636 138.338V139.536H263.917V138.338H264.636ZM264.275 139.178H267.874V139.896H264.275V139.178ZM267.514 139.536V138.338H268.232V139.536H267.514ZM267.872 138.698H267.145V137.98H267.872V138.698ZM266.789 138.376C266.751 138.015 266.445 137.737 266.073 137.737V137.018C266.814 137.018 267.423 137.577 267.505 138.299L266.789 138.379V138.376ZM266.073 137.737C265.701 137.737 265.396 138.018 265.357 138.376L264.641 138.296C264.724 137.577 265.332 137.016 266.073 137.016V137.734V137.737Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.246 128.02C284.246 128.053 284.265 128.106 284.331 128.169C284.4 128.235 284.507 128.301 284.659 128.362C284.956 128.483 285.386 128.56 285.865 128.56C286.344 128.56 286.771 128.483 287.071 128.362C287.223 128.301 287.33 128.235 287.399 128.169C287.468 128.103 287.484 128.053 287.484 128.02C287.484 127.987 287.465 127.935 287.399 127.872C287.33 127.805 287.223 127.739 287.071 127.679C286.774 127.558 286.344 127.48 285.865 127.48C285.386 127.48 284.959 127.558 284.659 127.679C284.507 127.739 284.4 127.805 284.331 127.872C284.262 127.938 284.246 127.987 284.246 128.02Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.568 128.02C279.568 128.053 279.587 128.106 279.653 128.169C279.722 128.235 279.83 128.301 279.981 128.362C280.278 128.483 280.708 128.56 281.187 128.56C281.667 128.56 282.093 128.483 282.394 128.362C282.545 128.301 282.652 128.235 282.721 128.169C282.79 128.103 282.807 128.053 282.807 128.02C282.807 127.987 282.787 127.935 282.721 127.872C282.652 127.805 282.545 127.739 282.394 127.679C282.096 127.558 281.667 127.48 281.187 127.48C280.708 127.48 280.281 127.558 279.981 127.679C279.83 127.739 279.722 127.805 279.653 127.872C279.584 127.938 279.568 127.987 279.568 128.02Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.169 128.02C274.169 128.053 274.189 128.106 274.255 128.169C274.324 128.235 274.431 128.301 274.583 128.362C274.88 128.483 275.31 128.56 275.789 128.56C276.268 128.56 276.695 128.483 276.995 128.362C277.147 128.301 277.254 128.235 277.323 128.169C277.392 128.103 277.408 128.053 277.408 128.02C277.408 127.987 277.389 127.935 277.323 127.872C277.254 127.805 277.147 127.739 276.995 127.679C276.698 127.558 276.268 127.48 275.789 127.48C275.31 127.48 274.883 127.558 274.583 127.679C274.431 127.739 274.324 127.805 274.255 127.872C274.186 127.938 274.169 127.987 274.169 128.02Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.494 128.02C269.494 128.053 269.513 128.106 269.579 128.169C269.648 128.235 269.755 128.301 269.907 128.362C270.204 128.483 270.634 128.56 271.113 128.56C271.592 128.56 272.019 128.483 272.319 128.362C272.471 128.301 272.578 128.235 272.647 128.169C272.716 128.103 272.732 128.053 272.732 128.02C272.732 127.987 272.713 127.935 272.647 127.872C272.578 127.805 272.471 127.739 272.319 127.679C272.022 127.558 271.592 127.48 271.113 127.48C270.634 127.48 270.207 127.558 269.907 127.679C269.755 127.739 269.648 127.805 269.579 127.872C269.51 127.938 269.494 127.987 269.494 128.02Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.455 128.02C264.455 128.053 264.474 128.106 264.54 128.169C264.609 128.235 264.716 128.301 264.868 128.362C265.165 128.483 265.595 128.56 266.074 128.56C266.553 128.56 266.98 128.483 267.28 128.362C267.432 128.301 267.539 128.235 267.608 128.169C267.677 128.103 267.693 128.053 267.693 128.02C267.693 127.987 267.674 127.935 267.608 127.872C267.539 127.805 267.432 127.739 267.28 127.679C266.983 127.558 266.553 127.48 266.074 127.48C265.595 127.48 265.168 127.558 264.868 127.679C264.716 127.739 264.609 127.805 264.54 127.872C264.471 127.938 264.455 127.987 264.455 128.02Z",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.329 121.184L281.188 123.522H271.832L276.329 121.184Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.275404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.624 135.309H370.891V166.145H357.624V135.309Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.262 134.588H371.248V134.947H357.262V134.588Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.713 135.309H370.801V136.744H357.713V135.309Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.713 152.877H370.801V154.312H357.713V152.877Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.988 135.309H369.455V150.727H363.988V135.309Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.792 163.273H369.455V166.141H364.792V163.273Z",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.793 163.273H367.305V166.141H364.793V163.273Z",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.234 163.273H363.896V166.141H359.234V163.273Z",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.055 163.273H361.566V166.141H359.055V163.273Z",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.572 155.385H369.455V156.461H367.572V155.385Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.883 155.385H366.766V156.461H364.883V155.385Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 155.385H363.629V157.536H359.057V155.385Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.746 155.385H363.629V156.461H361.746V155.385Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 155.385H360.939V156.461H359.057V155.385Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.988 137.459H369.455V141.046H363.988V137.459Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.988 142.477H369.455V146.064H363.988V142.477Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.988 147.139H369.455V150.726H363.988V147.139Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 137.459H365.152V141.046H364.077V137.459Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 142.477H365.152V146.064H364.077V142.477Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 147.139H365.152V150.726H364.077V147.139Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.713 151.441H370.801V151.801H357.713V151.441Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 137.459H361.387V141.046H359.057V137.459Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 142.477H361.387V146.064H359.057V142.477Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 147.139H361.387V150.726H359.057V147.139Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 137.459H359.773V141.046H359.057V137.459Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.057 142.477H359.773V146.064H359.057V142.477Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.055 147.139H359.771V150.726H359.055V147.139Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.779 137.459H368.109V141.046H365.779V137.459Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.779 142.477H368.109V146.064H365.779V142.477Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.779 147.139H368.109V150.726H365.779V147.139Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.274443
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.237 158.975C398.45 158.975 384.031 144.556 384.031 126.769C384.031 108.982 398.45 94.5625 416.237 94.5625C434.024 94.5625 448.443 108.982 448.443 126.769C448.443 144.556 434.024 158.975 416.237 158.975ZM416.237 156.249C399.955 156.249 386.757 143.05 386.757 126.769C386.757 110.487 399.955 97.2883 416.237 97.2883C432.519 97.2883 445.718 110.487 445.718 126.769C445.718 143.05 432.519 156.249 416.237 156.249Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.239 143.982C406.734 143.982 399.028 136.352 399.028 126.941C399.028 117.53 406.734 109.9 416.239 109.9C425.744 109.9 433.449 117.53 433.449 126.941C433.449 136.352 425.744 143.982 416.239 143.982ZM416.239 141.598C408.051 141.598 401.413 135.038 401.413 126.944C401.413 118.85 408.051 112.29 416.239 112.29C424.427 112.29 431.065 118.85 431.065 126.944C431.065 135.038 424.427 141.598 416.239 141.598Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.237 158.975C398.45 158.975 384.031 144.556 384.031 126.769C384.031 108.982 398.45 94.5625 416.237 94.5625C434.024 94.5625 448.443 108.982 448.443 126.769C448.443 144.556 434.024 158.975 416.237 158.975Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.898 156.252V158.978",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.862 155.74L422.373 158.296",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.236 156.253C399.955 156.253 386.756 143.054 386.756 126.772C386.756 110.491 399.955 97.292 416.236 97.292C432.518 97.292 445.717 110.491 445.717 126.772C445.717 143.054 432.518 156.253 416.236 156.253Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 152.846C401.841 152.846 390.168 141.25 390.168 126.945C390.168 112.64 401.841 101.043 416.239 101.043C430.638 101.043 442.311 112.64 442.311 126.945C442.311 141.25 430.638 152.846 416.239 152.846Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.238 149.434C403.909 149.434 393.915 139.364 393.915 126.942C393.915 114.519 403.909 104.449 416.238 104.449C428.566 104.449 438.561 114.519 438.561 126.942C438.561 139.364 428.566 149.434 416.238 149.434Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 146.707C405.416 146.707 396.642 137.857 396.642 126.94C396.642 116.024 405.416 107.174 416.239 107.174C427.062 107.174 435.836 116.024 435.836 126.94C435.836 137.857 427.062 146.707 416.239 146.707Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 143.982C406.734 143.982 399.028 136.353 399.028 126.941C399.028 117.53 406.734 109.9 416.239 109.9C425.744 109.9 433.449 117.53 433.449 126.941C433.449 136.353 425.744 143.982 416.239 143.982Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.238 141.595C408.05 141.595 401.412 135.034 401.412 126.941C401.412 118.848 408.05 112.287 416.238 112.287C424.426 112.287 431.064 118.848 431.064 126.941C431.064 135.034 424.426 141.595 416.238 141.595Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 136.143C411.063 136.143 406.867 132.023 406.867 126.941C406.867 121.858 411.063 117.738 416.239 117.738C421.415 117.738 425.611 121.858 425.611 126.941C425.611 132.023 421.415 136.143 416.239 136.143Z",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.303 161.19H398.007C398.416 160.509 398.176 159.656 398.007 159.314H396.303C395.894 160.133 396.134 160.906 396.303 161.19Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.141 163.235H405.845C406.254 162.554 406.014 161.701 405.845 161.359H404.141C403.732 162.178 403.972 162.951 404.141 163.235Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.297 164.598H413.001C413.41 163.917 413.17 163.064 413.001 162.723H411.297C410.888 163.542 411.128 164.314 411.297 164.598Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.794 164.598H420.497C420.906 163.917 420.666 163.064 420.497 162.723H418.794C418.384 163.542 418.624 164.314 418.794 164.598Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.608 163.579H427.311C427.721 162.898 427.481 162.045 427.311 161.703H425.608C425.198 162.522 425.438 163.294 425.608 163.579Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.167 156.764H391.87C392.279 156.083 392.039 155.23 391.87 154.889H390.167C389.757 155.708 389.997 156.48 390.167 156.764Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.713 150.627H386.417C386.826 149.947 386.586 149.094 386.417 148.752H384.713C384.304 149.571 384.544 150.343 384.713 150.627Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.963 143.811H382.667C383.076 143.13 382.836 142.277 382.667 141.936H380.963C380.554 142.755 380.794 143.527 380.963 143.811Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.237 136.313H379.94C380.35 135.632 380.11 134.779 379.94 134.438H378.237C377.827 135.257 378.067 136.029 378.237 136.313Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.557 128.475H379.261C379.67 127.794 379.43 126.941 379.261 126.6H377.557C377.148 127.419 377.388 128.191 377.557 128.475Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.581 120.635H380.284C380.693 119.954 380.454 119.101 380.284 118.76H378.581C378.171 119.579 378.411 120.351 378.581 120.635Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.305 113.137H383.009C383.418 112.456 383.178 111.603 383.009 111.262H381.305C380.896 112.081 381.136 112.853 381.305 113.137Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.055 105.983H386.759C387.168 105.302 386.928 104.449 386.759 104.107H385.055C384.646 104.926 384.886 105.699 385.055 105.983Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.508 100.531H392.212C392.621 99.8499 392.381 98.997 392.212 98.6553H390.508C390.099 99.4743 390.339 100.246 390.508 100.531Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.983 95.7602H398.686C399.096 95.0794 398.856 94.2265 398.686 93.8848H396.983C396.573 94.7038 396.813 95.4759 396.983 95.7602Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.141 93.0278H405.845C406.254 92.347 406.014 91.494 405.845 91.1523H404.141C403.732 91.9714 403.972 92.7435 404.141 93.0278Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.979 91.3266H413.682C414.092 90.6458 413.852 89.7929 413.682 89.4512H411.979C411.57 90.2702 411.81 91.0423 411.979 91.3266Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.815 91.6665H421.518C421.928 90.9857 421.688 90.1327 421.518 89.791H419.815C419.406 90.6101 419.646 91.3822 419.815 91.6665Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.655 93.3735H429.358C429.768 92.6927 429.528 91.8398 429.358 91.498H427.655C427.245 92.3171 427.485 93.0892 427.655 93.3735Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.887 106.152L416.578 126.772",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.605 100.526L416.579 126.767",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.469 96.2715L416.578 126.602",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.654 93.3711L416.407 126.6",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.326 91.6699L416.406 126.602",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.999 91.3252L416.236 126.088",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.672 93.0312L416.236 126.602",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.684 95.7578L416.236 126.772",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.38 99.8457L416.236 126.77",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.928 105.131L416.236 126.773",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.181 111.605L415.898 126.771",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.283 118.762L416.068 126.77",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.578 126.6L416.408 126.941",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.261 134.438L415.896 126.941",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.816 141.764L416.236 126.938",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.564 148.755L416.406 126.773",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.848 154.884L416.066 126.938",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.153 159.317L416.408 126.77",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.82 161.19L416.406 126.77",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.979 112.455L416.408 126.94",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.021 119.783L416.578 126.941",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.703 127.454L416.237 126.773",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.191 135.118L416.406 126.938",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.488 142.62L415.895 126.773",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.57 149.434L416.579 126.941",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.117 155.227L416.069 126.6",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.643 159.657L416.24 126.598",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.975 161.703L416.238 126.43",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.646 162.724L416.237 126.6",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.976 162.554L416.408 126.6",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.509 99.8464L429.701 97.6318",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.714 97.9742L423.395 95.418",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.578 94.5625V97.2883",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.764 95.248L410.275 97.8043",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.286 97.292L404.479 99.6787",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.494 100.699L399.027 102.744",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.553 104.959L394.598 106.834",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.463 110.582L390.678 111.774",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.736 116.549L388.123 117.402",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.204 123.189L386.93 123.531",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.204 130.006L386.76 129.664",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.395 136.316L387.951 135.635",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.291 142.448L390.506 141.084",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.212 147.903L394.088 146.369",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.156 152.502L398.689 150.457",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.118 155.906L404.141 153.691",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.252 155.568L408.571 157.955",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.301 94.9053L427.315 96.439",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.484 91.6699L420.838 94.907",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.611 95.928L421.691 91.1572",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.477 90.4717L414.364 94.5617",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.963 94.7361L413.85 90.4766",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.549 95.7603L411.639 90.8174",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.146 94.7344L406.011 91.3252",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.971 92.6914L401.073 98.3152",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.674 96.2691L399.028 94.7354",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.154 95.7578L395.621 102.062",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.537 98.997L392.21 98.6553",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.088 103.424L386.761 104.105",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.018 106.661V100.526",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.654 108.537L382.327 111.093",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.271 112.627L386.419 105.98",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.588 113.994L379.43 118.765",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.885 119.105L382.498 113.143",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.713 120.295L378.75 126.599",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.283 120.467L384.031 125.749",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.031 127.623L379.26 134.269",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.543 132.564L379.43 127.963",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.713 134.098L381.815 141.766",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.418 138.872L380.113 134.951",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.93 140.4L385.565 148.58",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.486 144.834L382.84 142.619",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.508 146.197L390.678 154.716",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.419 148.922L394.088 150.114",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.109 151.135L396.812 159.315",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.197 154.035L391.87 154.888",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.004 159.319L406.012 157.615",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.561 154.715L403.971 161.531",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.609 157.615L433.789 159.66",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.914 155.059L427.313 161.533",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.132 165.793L416.922 126.43L416.241 128.644L431.237 165.791H434.135L434.132 165.793Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.368 166.475L415.725 125.75L416.406 127.965L401.752 166.475H399.365H399.368Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.409 130.01C414.715 130.01 413.342 128.637 413.342 126.942C413.342 125.248 414.715 123.875 416.409 123.875C418.103 123.875 419.477 125.248 419.477 126.942C419.477 128.637 418.103 130.01 416.409 130.01Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93 157.785L420.498 162.556",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.157 158.807L425.439 161.874",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.939 158.977L413.169 162.725",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.169 158.977L418.793 162.897",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.465 158.635L406.013 161.533",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.206 157.785L411.127 162.728",
    stroke: "#615E66",
    strokeWidth: 0.260842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.156 157.365H371.535V165.054H356.156V157.365Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.156 161.977H371.535V165.053H356.156V161.977Z",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.154 163.252H369.383V165.055H368.154V163.252Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.662 163.252H366.891V165.055H365.662V163.252Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.783 163.252H364.012V165.055H362.783V163.252Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.287 163.252H361.516V165.055H360.287V163.252Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.599 163.252H358.828V165.055H357.599V163.252Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.158 158.26H369.387V161.023H368.158V158.26Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.662 158.26H366.891V161.023H365.662V158.26Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.783 158.26H364.012V161.023H362.783V158.26Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.287 158.26H361.516V161.023H360.287V158.26Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.599 158.26H358.828V161.023H357.599V158.26Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.783 153.443L371.078 157.363H356.605L363.783 153.443Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.844 157.826L372.613 157.301L363.687 152.598L355.05 157.301L355.697 157.981L363.847 153.52L371.844 157.826Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 138.153L282.562 156.453V157.991L298.403 154.914L362.071 141.995L365.762 143.226L351 152.454L343.617 158.913C347.617 156.915 356.32 152.64 359.149 151.531C362.688 150.147 376.988 143.226 378.987 142.303C382.831 140.528 381.602 138.151 378.987 137.689C372.097 136.213 362.48 137.381 358.533 138.151V138.153Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.019 166.294H292.252L293.335 162.413C293.718 161.04 292.685 159.682 291.261 159.682H282.562V157.989L360.242 142.453C362.789 141.944 365.371 141.631 367.968 141.52C368.881 141.483 369.255 142.676 368.483 143.166L343.554 159.018C342.233 159.856 341.661 161.49 342.167 162.968L343.304 166.292H339.46V161.829C339.46 161.172 338.791 160.725 338.184 160.977L335.001 162.295V159.68L352.379 147.53C353.022 147.18 352.598 146.113 351.889 146.299C339.185 149.618 319.248 153.893 313.01 155.374C307.33 156.723 301.781 158.189 298.532 159.23C297.249 159.64 296.489 160.899 296.619 162.238L297.016 166.292L297.019 166.294Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.252 155.99V159.99",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.096 155.375V159.219",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.244 153.377V156.915",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.326 154.605V158.758",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.555 153.992V157.836",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.404 159.99L299.631 158.605",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.387 166.293V162.082C340.387 161.148 340.809 160.265 341.543 159.686C343.158 158.412 345.279 156.767 347.275 155.248C348.532 154.238 350.055 153.101 351.889 151.833C352.141 151.656 352.362 151.503 352.558 151.373C356.006 149.026 360.477 146.256 366.223 143.068C359.151 146.99 354.876 149.832 352.56 151.371H352.558C352.329 151.529 352.108 151.679 351.889 151.83C350.752 152.631 349.062 153.888 347.275 155.246C343.845 157.995 342.397 159.785 342.077 160.599V166.289H340.385L340.387 166.293Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.194 161.631L294.25 166.141H297.018C296.917 165.731 296.957 164.418 296.71 162.45C296.463 160.482 297.532 159.681 298.247 159.528L310.549 155.99L297.725 159.032C296.449 159.335 295.46 160.348 295.194 161.631Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.004 160.758L360.378 145.996L366.376 143.074",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 138.152L282.562 156.452V155.53L358.533 135.998C362.994 135.127 373.328 133.908 378.987 135.998C381.202 136.737 382.318 137.434 382.678 137.691C382.678 138.922 382.831 140.306 382.064 140.92C381.449 141.412 356.176 153.121 343.617 158.912C347.617 156.914 356.32 152.639 359.149 151.53C362.688 150.146 376.988 143.225 378.987 142.302C382.831 140.527 381.602 138.15 378.987 137.688C372.097 136.212 362.48 137.38 358.533 138.15V138.152Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.562 153.992V155.529L304.246 149.993C321.416 145.226 358.01 135.536 366.991 134.922C375.971 134.308 381.19 136.511 382.676 137.69V134.656C382.676 133.926 382.469 133.194 381.901 132.74C380.437 131.575 377.61 130.433 374.987 130.308C366.868 129.569 357.662 131.64 354.072 132.768L282.562 153.99V153.992Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.562 156.297V157.989",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.92 146.304L366.221 143.074",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.529 137.076L366.375 141.537",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.605 137.691L364.835 141.691",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.988 137.076L367.605 141.537",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.301 137.227V141.688",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.951 149.547C395.913 149.547 394.26 151.199 394.26 153.238V157.852C394.26 159.891 395.913 161.543 397.951 161.543C399.99 161.543 401.643 159.891 401.643 157.852V153.238C401.643 151.199 399.99 149.547 397.951 149.547Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.492 150.623C395.792 150.623 394.415 152 394.415 153.7V158.005C394.415 159.705 395.792 161.082 397.492 161.082C399.191 161.082 400.568 159.705 400.568 158.005V153.7C400.568 152 399.191 150.623 397.492 150.623Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.109 153.701V165.081",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.803 154.623L397.957 156.777",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.107 157.082L397.953 159.236",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.107 154.623L397.953 156.777",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.731 149.547C378.692 149.547 377.04 151.199 377.04 153.238C377.04 155.277 378.692 156.929 380.731 156.929C382.769 156.929 384.422 155.277 384.422 153.238C384.422 151.199 382.769 149.547 380.731 149.547Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.729 150.93H380.421C378.806 150.93 377.499 152.239 377.499 153.851C377.499 155.466 378.808 156.772 380.421 156.772H380.729C382.344 156.772 383.65 155.464 383.65 153.851C383.65 152.236 382.342 150.93 380.729 150.93Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.883 153.701V165.081",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.733 154.006L380.887 156.16",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.881 154.006L380.727 156.16",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.033 159.104C393.033 157.79 392.762 156.493 392.239 155.29L391.715 154.085C390.695 151.745 387.376 151.745 386.357 154.085L385.832 155.29C385.307 156.493 385.038 157.79 385.038 159.104C385.038 159.431 385.304 159.697 385.632 159.697H392.442C392.769 159.697 393.035 159.431 393.035 159.104H393.033Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.957 158.956C391.957 157.885 391.733 156.826 391.298 155.846L391.048 155.286C390.095 153.139 387.049 153.139 386.095 155.286L385.846 155.846C385.413 156.826 385.187 157.885 385.187 158.956C385.187 159.281 385.45 159.547 385.778 159.547H391.364C391.689 159.547 391.955 159.283 391.955 158.956H391.957Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.033 157.391V164.926",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.035 156.775L389.033 158.621",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.572 157.697L389.035 159.39",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.759 164.907C411.188 163.619 410.985 161.321 409.351 160.305L406.642 158.619C406.223 158.36 405.691 158.37 405.286 158.647L402.882 160.288C401.326 161.352 401.119 163.567 402.452 164.9C402.468 164.916 402.492 164.926 402.515 164.926H409.707C409.726 164.926 409.747 164.918 409.761 164.904L409.759 164.907Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.761 164.904C409.747 164.918 409.726 164.926 409.707 164.926H402.515C402.492 164.926 402.468 164.916 402.452 164.9C401.119 163.567 401.326 161.352 402.882 160.288L405.286 158.647C405.691 158.37 406.223 158.36 406.642 158.619L409.351 160.305C410.985 161.321 411.188 163.619 409.759 164.907L409.761 164.904ZM409.761 164.904L409.865 165.02",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.542 164.708C410.479 163.585 410.178 161.89 408.914 161.156L405.879 159.397C405.545 159.204 405.131 159.209 404.799 159.409L402.72 160.678C401.242 161.58 401.138 163.687 402.518 164.732C402.551 164.758 402.591 164.769 402.633 164.769H409.406C409.46 164.769 409.512 164.746 409.545 164.704L409.542 164.708Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 162.312V164.772",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.412 161.699L406.41 163.545",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.949 162.621L406.412 164.314",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.968 165.08H375.567C374.776 165.08 374.016 164.781 373.439 164.241L373.023 163.853C372.886 163.726 372.787 163.566 372.733 163.387L372.695 163.255C372.406 162.278 373.59 161.541 374.339 162.236V161.713C374.339 160.637 375.69 160.155 376.37 160.991C376.045 159.691 377.538 158.705 378.604 159.515L378.908 159.745L378.99 159.489C379.277 158.596 380.247 158.119 381.128 158.436C382.008 158.754 382.451 159.736 382.107 160.604L381.954 160.991C383.263 160.991 383.993 162.499 383.18 163.526L382.566 164.303C382.178 164.792 381.587 165.08 380.963 165.08H380.968Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.193 164.925L381.039 162.004",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.807 163.696L378.731 161.389",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.576 165.079L375.039 163.08",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.732 162.621L375.657 163.697",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.654 164.925L380.73 159.85",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.258 149.547C164.219 149.547 162.567 151.199 162.567 153.238V157.852C162.567 159.891 164.219 161.543 166.258 161.543C168.297 161.543 169.949 159.891 169.949 157.852V153.238C169.949 151.199 168.297 149.547 166.258 149.547Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.796 150.623C164.097 150.623 162.72 152 162.72 153.7V158.005C162.72 159.705 164.097 161.082 165.796 161.082C167.496 161.082 168.873 159.705 168.873 158.005V153.7C168.873 152 167.496 150.623 165.796 150.623Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.412 153.701V165.081",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.106 154.623L166.26 156.777",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.412 157.082L166.258 159.236",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.412 154.623L166.258 156.777",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.035 149.547C146.997 149.547 145.344 151.199 145.344 153.238C145.344 155.277 146.997 156.929 149.035 156.929C151.074 156.929 152.727 155.277 152.727 153.238C152.727 151.199 151.074 149.547 149.035 149.547Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.038 150.93H148.729C147.114 150.93 145.808 152.239 145.808 153.851C145.808 155.466 147.117 156.772 148.729 156.772H149.038C150.652 156.772 151.959 155.464 151.959 153.851C151.959 152.236 150.65 150.93 149.038 150.93Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.188 153.701V165.081",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.037 154.006L149.191 156.16",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.186 154.006L149.032 156.16",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.337 159.104C161.337 157.79 161.067 156.493 160.544 155.29L160.019 154.085C159 151.745 155.681 151.745 154.661 154.085L154.136 155.29C153.611 156.493 153.343 157.79 153.343 159.104C153.343 159.431 153.609 159.697 153.936 159.697H160.747C161.074 159.697 161.34 159.431 161.34 159.104H161.337Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.262 158.956C160.262 157.885 160.038 156.826 159.603 155.846L159.353 155.286C158.4 153.139 155.354 153.139 154.4 155.286L154.151 155.846C153.717 156.826 153.491 157.885 153.491 158.956C153.491 159.281 153.755 159.547 154.082 159.547H159.668C159.993 159.547 160.259 159.283 160.259 158.956H160.262Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.338 157.391V164.926",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.339 156.775L157.338 158.621",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.877 157.697L157.34 159.39",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.063 164.907C179.492 163.619 179.29 161.321 177.656 160.305L174.947 158.619C174.528 158.36 173.996 158.37 173.591 158.647L171.187 160.288C169.631 161.352 169.424 163.567 170.756 164.9C170.773 164.916 170.796 164.926 170.82 164.926H178.012C178.03 164.926 178.052 164.918 178.066 164.904L178.063 164.907Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.066 164.904C178.052 164.918 178.03 164.926 178.012 164.926H170.82C170.796 164.926 170.773 164.916 170.756 164.9C169.424 163.567 169.631 161.352 171.187 160.288L173.591 158.647C173.996 158.37 174.528 158.36 174.947 158.619L177.656 160.305C179.29 161.321 179.492 163.619 178.063 164.907L178.066 164.904ZM178.066 164.904L178.169 165.02",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.847 164.708C178.784 163.585 178.483 161.89 177.218 161.156L174.184 159.397C173.85 159.204 173.435 159.209 173.103 159.409L171.025 160.678C169.546 161.58 169.443 163.687 170.822 164.732C170.855 164.758 170.895 164.769 170.938 164.769H177.71C177.765 164.769 177.816 164.746 177.849 164.704L177.847 164.708Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.719 162.312V164.772",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.716 161.699L174.715 163.545",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.254 162.621L174.717 164.314",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.274 165.08H143.874C143.083 165.08 142.323 164.781 141.746 164.241L141.329 163.853C141.193 163.726 141.094 163.566 141.04 163.387L141.002 163.255C140.713 162.278 141.897 161.541 142.645 162.236V161.713C142.645 160.637 143.996 160.155 144.677 160.991C144.352 159.691 145.844 158.705 146.911 159.515L147.214 159.745L147.297 159.489C147.584 158.596 148.554 158.119 149.434 158.436C150.315 158.754 150.757 159.736 150.414 160.604L150.261 160.991C151.569 160.991 152.299 162.499 151.487 163.526L150.873 164.303C150.484 164.792 149.893 165.08 149.27 165.08H149.274Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 164.925L149.346 162.004",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.113 163.696L147.037 161.389",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.885 165.079L143.348 163.08",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.037 162.621L143.961 163.697",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.958 164.925L149.035 159.85",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.043 148.615C290.005 148.615 288.352 150.268 288.352 152.306V156.92C288.352 158.959 290.005 160.612 292.043 160.612C294.082 160.612 295.734 158.959 295.734 156.92V152.306C295.734 150.268 294.082 148.615 292.043 148.615Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.581 149.689C289.882 149.689 288.505 151.067 288.505 152.766V157.072C288.505 158.771 289.882 160.149 291.581 160.149C293.281 160.149 294.658 158.771 294.658 157.072V152.766C294.658 151.067 293.281 149.689 291.581 149.689Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.199 152.764V166.297",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.892 153.688L292.199 156.253",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.197 156.15L292.199 158.149",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.199 153.688L292.201 155.686",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.971 154.148C278.932 154.148 277.28 155.801 277.28 157.84C277.28 159.878 278.932 161.531 280.971 161.531C283.01 161.531 284.662 159.878 284.662 157.84C284.662 155.801 283.01 154.148 280.971 154.148Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.971 155.535H280.663C279.048 155.535 277.741 156.844 277.741 158.457C277.741 160.071 279.05 161.378 280.663 161.378H280.971C282.586 161.378 283.893 160.069 283.893 158.457C283.893 156.842 282.584 155.535 280.971 155.535Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.125 158.301V166.144",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.975 158.609L281.129 160.763",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.123 158.609L280.969 160.763",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.976 166.147C301.976 166.147 302.03 166.081 302.056 166.048C303.077 164.727 302.771 162.755 301.291 161.832L298.581 160.146C298.162 159.887 297.63 159.897 297.225 160.175L294.819 161.815C293.414 162.776 293.11 164.676 294.045 166.017C294.075 166.06 294.139 166.147 294.139 166.147H301.973H301.976Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.488 165.964C302.411 164.855 302.114 163.184 300.867 162.459L297.875 160.724C297.543 160.533 297.133 160.538 296.811 160.736L294.76 161.988C293.301 162.878 293.197 164.956 294.56 165.987C294.591 166.011 294.631 166.025 294.673 166.025H301.352C301.406 166.025 301.455 166.002 301.49 165.962L301.488 165.964Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35 163.84V166.147",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.351 163.229L298.35 165.074",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.887 164.148L298.35 165.841",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.557 166.145C281.557 166.145 281.215 165.912 281.062 165.769L280.648 165.38C280.509 165.253 280.41 165.093 280.359 164.914L280.319 164.782C280.029 163.806 281.213 163.069 281.962 163.763V163.241C281.962 162.165 283.315 161.682 283.996 162.518C283.671 161.218 285.161 160.232 286.232 161.042L286.536 161.273L286.616 161.016C286.905 160.124 287.873 159.646 288.755 159.964C289.636 160.282 290.078 161.263 289.732 162.132L289.579 162.518C290.886 162.518 291.618 164.027 290.806 165.053L290.194 165.83C290.102 165.948 289.883 166.145 289.883 166.145H281.557Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.012 166.149L288.662 163.533",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.66 165.117L286.354 162.916",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.848 166.147L282.664 164.609",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.355 164.148L283.178 165.278",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.463 166.148L288.352 161.381",
    stroke: "#615E66",
    strokeWidth: 0.235406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.758 149.547C434.796 149.547 436.449 151.199 436.449 153.238V157.852C436.449 159.891 434.796 161.543 432.758 161.543C430.719 161.543 429.066 159.891 429.066 157.852V153.238C429.066 151.199 430.719 149.547 432.758 149.547Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.95 164.907C419.521 163.619 419.724 161.321 421.358 160.305L424.067 158.619C424.486 158.36 425.018 158.37 425.423 158.647L427.827 160.288C429.383 161.352 429.59 163.567 428.257 164.9C428.241 164.916 428.217 164.926 428.194 164.926H421.002C420.983 164.926 420.962 164.918 420.948 164.904L420.95 164.907Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.948 164.904C420.962 164.918 420.983 164.926 421.002 164.926H428.194C428.217 164.926 428.241 164.916 428.257 164.9C429.59 163.567 429.383 161.352 427.827 160.288L425.423 158.647C425.018 158.37 424.486 158.36 424.067 158.619L421.358 160.305C419.724 161.321 419.521 163.619 420.95 164.907L420.948 164.904ZM420.948 164.904L420.844 165.02",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.167 164.708C420.23 163.585 420.531 161.89 421.795 161.156L424.83 159.397C425.164 159.204 425.578 159.209 425.91 159.409L427.989 160.678C429.467 161.58 429.571 163.687 428.191 164.732C428.158 164.758 428.118 164.769 428.076 164.769H421.303C421.249 164.769 421.197 164.746 421.164 164.704L421.167 164.708Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.295 162.312V164.772",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.295 161.699L424.297 163.545",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76 162.621L424.297 164.314",
    stroke: "#615E66",
    strokeWidth: 0.235406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2675 131.158H133.33V166.332H77.2675V131.158Z",
    fill: "#F7F5F0",
    stroke: "#615E66",
    strokeWidth: 0.218168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0175 155.863H132.898V163.703H78.0175V155.863Z",
    fill: "#D9D9D9",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.824 155.863H125.303V163.703H120.824V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.261 155.863H131.74V163.703H127.261V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.982 155.863H119.461V163.703H114.982V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.261 155.863H112.74V163.703H108.261V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54 155.863H106.02V163.703H101.54V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8197 155.863H99.2988V163.703H94.8197V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0989 155.863H92.5781V163.703H88.0989V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3783 155.863H85.8574V163.703H81.3783V155.863Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4551 136.539H133.459V144.379H77.4551V136.539Z",
    fill: "#EFCDBD",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4551 136.539H133.459V137.658H77.4551V136.539Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.457 146.623H133.461V147.742H77.457V146.623Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.457 155.863H133.461V156.982H77.457V155.863Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.457 130.66H133.461V134.299H77.457V130.66Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.457 130.66H133.461V131.779H77.457V130.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1771 132.9H133.738V134.581H77.1771V132.9Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.419 136.539H132.898V141.58H128.419V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.378 136.539H127.857V141.58H123.378V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.341 136.539H122.82V141.58H118.341V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3 136.539H117.779V141.58H113.3V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.261 136.539H112.74V141.58H108.261V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22 136.539H107.699V141.58H103.22V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1791 136.539H102.658V141.58H98.1791V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.138 136.539H97.6172V141.58H93.138V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0989 136.539H92.5781V141.58H88.0989V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0579 136.539H87.5371V141.58H83.0579V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0188 136.539H82.498V141.58H78.0188V136.539Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.419 146.623H132.898V151.102H128.419V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.378 146.623H127.857V151.102H123.378V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.341 146.623H122.82V151.102H118.341V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3 146.623H117.779V151.102H113.3V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.261 146.623H112.74V151.102H108.261V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22 146.623H107.699V151.102H103.22V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1791 146.623H102.658V151.102H98.1791V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.138 146.623H97.6172V151.102H93.138V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0989 146.623H92.5781V151.102H88.0989V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0579 146.623H87.5371V151.102H83.0579V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0188 146.623H82.498V151.102H78.0188V146.623Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.428623
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4607 119.33H100.211V130.703H77.4607V119.33Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4607 126.15H100.211V130.702H77.4607V126.15Z",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2153 128.035H97.0332V130.703H95.2153V128.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.524 128.035H93.3418V130.703H91.524V128.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2682 128.035H89.0859V130.703H87.2682V128.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5787 128.035H85.3965V130.703H83.5787V128.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6002 128.035H81.418V130.703H79.6002V128.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2153 120.65H97.0332V124.739H95.2153V120.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.524 120.65H93.3418V124.739H91.524V120.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2682 120.65H89.0859V124.739H87.2682V120.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5787 120.65H85.3965V124.739H83.5787V120.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6002 120.65H81.418V124.739H79.6002V120.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7453 113.527L99.5371 119.325H78.1311L88.7453 113.527Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.67 120.012L101.809 119.235L88.6035 112.277L75.8232 119.235L76.7844 120.241L88.8403 113.642L100.67 120.012Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.348235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.5671 116.242H64.0781V145.377H-8.5671V116.242Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.5671 136.443H64.0781V145.378H-8.5671V136.443Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.027 122.07H60.582V125.956H59.027V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.701 118.375H66.2168V119.541H-10.701V118.375Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.027 130.225H60.582V134.111H59.027V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6393 138.383H62.5254V145.376H58.6393V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.317 138.383H55.1445V145.376H49.317V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7701 138.383H46.5977V145.376H40.7701V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2233 138.383H38.0508V145.376H32.2233V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2802 139.739C30.2802 138.345 29.1504 137.215 27.7559 137.215C26.3615 137.215 25.2317 138.345 25.2317 139.739V145.373H30.2832V139.739H30.2802Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4615 138.383H23.2891V145.376H17.4615V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9146 138.383H14.7422V145.376H8.9146V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.017036 138.383H5.81055V145.376H-0.017036V138.383Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6393 139.549H62.5254V145.376H58.6393V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.317 139.549H55.1445V145.376H49.317V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7701 139.549H46.5977V145.376H40.7701V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2233 139.549H38.0508V145.376H32.2233V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2802 140.907C30.2802 139.513 29.1504 138.383 27.7559 138.383C26.3615 138.383 25.2317 139.513 25.2317 140.907V145.376H30.2832V140.907H30.2802Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4615 139.549H23.2891V145.376H17.4615V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9146 139.549H14.7422V145.376H8.9146V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.017036 139.549H5.81055V145.376H-0.017036V139.549Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4235 122.07H53.9785V125.956H52.4235V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4235 130.225H53.9785V134.111H52.4235V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1501 122.07H49.7051V125.956H48.1501V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1501 130.225H49.7051V134.111H48.1501V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8766 122.07H45.4316V125.956H43.8766V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8786 130.225H45.4336V134.111H43.8786V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9919 122.07H41.5469V125.956H39.9919V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9919 130.225H41.5469V134.111H39.9919V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3298 122.07H36.8848V125.956H35.3298V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3298 130.225H36.8848V134.111H35.3298V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.445 122.07H33V125.956H31.445V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4489 130.225H33.0039V134.111H31.4489V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7848 122.07H28.3398V125.956H26.7848V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7848 130.225H28.3398V134.111H26.7848V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1227 122.07H23.6777V125.956H22.1227V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1227 130.225H23.6777V134.111H22.1227V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8493 122.07H19.4043V125.956H17.8493V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8493 130.225H19.4043V134.111H17.8493V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 122.07H15.5195V125.956H13.9645V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 130.225H15.5195V134.111H13.9645V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30438 122.07H10.8594V125.956H9.30438V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30438 130.225H10.8594V134.111H9.30438V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02898 122.07H6.58398V125.956H5.02898V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03094 130.225H6.58594V134.111H5.03094V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14813 122.07H2.70312V125.956H1.14813V122.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14813 130.225H2.70312V134.111H1.14813V130.225Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.7291 116.242H65.2441V118.573H-9.7291V116.242Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4726 117.018H64.0762V117.794H57.4726V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1543 117.018H54.7578V117.794H48.1543V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.83 117.018H45.4336V117.794H38.83V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5058 117.018H36.1094V117.794H29.5058V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1816 117.018H26.7852V117.794H20.1816V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 117.018H17.4648V117.794H10.8613V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53699 117.018H8.14062V117.794H1.53699V117.018Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0797 114.494L25.4602 114.572L25.3977 114.884H25.0797V114.494ZM23.486 114.494H23.0965V114.105H23.486V114.494ZM23.486 116.436V116.825H23.0965V116.436H23.486ZM31.2551 116.436H31.6445V116.825H31.2551V116.436ZM31.2551 114.494V114.105H31.6445V114.494H31.2551ZM29.6614 114.494V114.884H29.3432L29.2808 114.572L29.6614 114.494ZM25.0797 114.884H23.486V114.108H25.0797V114.884ZM23.8725 114.494V116.436H23.0965V114.494H23.8725ZM23.486 116.046H31.2551V116.822H23.486V116.046ZM30.8656 116.436V114.494H31.6416V116.436H30.8656ZM31.2551 114.884H29.6614V114.108H31.2551V114.884ZM29.2808 114.572C29.1381 113.864 28.5078 113.329 27.7586 113.329V112.553C28.8854 112.553 29.8249 113.353 30.042 114.417L29.2808 114.572ZM27.7586 113.329H26.9825V112.553H27.7586V113.329ZM26.9825 113.329C26.2333 113.329 25.603 113.864 25.4602 114.572L24.6991 114.417C24.9161 113.353 25.8557 112.553 26.9825 112.553V113.329Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0785 114.493H23.4848V116.434H31.2539V114.493H29.6602C29.4818 113.606 28.6969 112.938 27.7574 112.938H26.9813C26.0418 112.938 25.2569 113.604 25.0785 114.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.736 166.73V144.588H221.306L230.241 139.343L239.565 143.033L250.637 136.43L252.775 166.73H132.739H132.736Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.066 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.396 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.725 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.057 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.387 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.719 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.051 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.379 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.713 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.045 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.375 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.705 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.037 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.367 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.699 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.029 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.688 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.02 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.35 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.682 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.012 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.346 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.674 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.004 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.336 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.666 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.996 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.328 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.66 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.992 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.982 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.645 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.975 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.305 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.637 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.967 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.299 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.629 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.959 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.293 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.625 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.955 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.281 147.695V166.73",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.613 147.111V166.729",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.945 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.275 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.607 146.143V166.732",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93 137.788C128.735 137.943 122.375 136.429 119.723 135.65C129.629 145.75 131.182 147.692 132.93 148.664C141.088 149.44 139.144 147.499 149.633 147.499C160.123 147.499 165.951 150.219 171.389 150.413C176.827 150.606 178.186 147.499 184.792 147.499C191.399 147.499 194.892 151.968 199.361 151.968C203.83 151.968 203.634 147.306 209.654 147.112C215.675 146.919 218.396 153.133 221.309 153.133C226.944 153.133 224.03 146.723 229.661 146.529C235.296 146.336 235.099 153.909 238.789 153.909C242.479 153.909 242.286 146.723 246.948 146.14C251.61 145.557 251.416 162.457 252.775 166.533C256.465 155.851 258.213 135.65 252.775 135.65C247.337 135.65 247.724 147.499 243.065 147.692C238.403 147.885 241.316 137.785 235.102 137.009C228.888 136.233 228.888 145.75 224.03 146.137C219.175 146.527 220.144 137.009 213.347 137.009C206.55 137.009 205.771 144.195 200.526 144.195C195.282 144.195 193.73 137.009 184.792 137.009C178.771 137.009 175.664 141.478 170.223 141.478C164.782 141.478 158.628 137.119 151.188 136.426C142.837 135.65 138.175 137.592 132.93 137.785V137.788Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.777 146.337C252.458 133.285 253.225 154.106 252.77 166.148C251.412 150.996 250.05 149.406 249.274 147.696C248.302 145.558 246.943 146.141 245.777 146.337Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.928 155.08H135.065",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.928 161.289H135.065",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.725 151.967H141.862",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.725 158.188H141.862",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.725 164.4H141.862",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.387 151.967H146.524",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.387 158.188H146.524",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.387 164.4H146.524",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.051 151.967H151.189",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.051 158.188H151.189",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.051 164.4H151.189",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.713 151.967H155.851",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.713 158.188H155.851",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.713 164.4H155.851",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.375 151.967H160.513",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.375 158.188H160.513",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.375 164.4H160.513",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.037 151.967H165.175",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.037 158.188H165.175",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.037 164.4H165.175",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.699 151.967H169.837",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.699 158.188H169.837",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.699 164.4H169.837",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357 151.967H174.495",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357 158.188H174.495",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357 164.4H174.495",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.02 151.967H179.157",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.02 158.188H179.157",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.02 164.4H179.157",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.682 151.967H183.819",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.682 158.188H183.819",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.682 164.4H183.819",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.346 151.967H188.483",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.346 158.188H188.483",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.346 164.4H188.483",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.004 151.967H193.142",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.004 158.188H193.142",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.004 164.4H193.142",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.666 151.967H197.804",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.666 158.188H197.804",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.666 164.4H197.804",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.328 151.967H202.466",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33 158.188H202.468",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33 164.4H202.468",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.992 151.967H207.13",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.992 158.188H207.13",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.992 164.4H207.13",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65 151.967H211.788",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65 158.188H211.788",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65 164.4H211.788",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 151.967H216.45",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 158.188H216.45",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 164.4H216.45",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.299 151.967H230.437",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.299 158.188H230.437",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.299 164.4H230.437",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.959 151.967H235.097",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.959 158.188H235.097",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.959 164.4H235.097",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.281 151.967H244.419",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.281 158.188H244.419",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.281 164.4H244.419",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.975 158.188H221.112",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.975 164.4H221.112",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.637 158.188H225.775",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.637 164.4H225.775",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26 151.967H137.398",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26 158.188H137.398",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26 164.4H137.398",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.59 155.08H139.728",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.59 161.289H139.728",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.254 155.08H144.392",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.254 161.289H144.392",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.916 155.08H149.054",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.916 161.289H149.054",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.576 155.08H153.714",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.576 161.289H153.714",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.234 155.08H158.372",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.234 161.289H158.372",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.898 155.08H163.036",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.898 161.289H163.036",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.561 155.08H167.698",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.561 161.289H167.698",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.223 155.08H172.36",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.223 161.289H172.36",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.885 155.08H177.023",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.885 161.289H177.023",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.549 155.08H181.687",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.549 161.289H181.687",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.205 155.08H186.343",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.205 161.289H186.343",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.867 155.08H191.005",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.867 161.289H191.005",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.527 155.08H195.665",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.527 161.289H195.665",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.191 155.08H200.329",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.191 161.289H200.329",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.854 155.08H204.991",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.854 161.289H204.991",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.516 155.08H209.653",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.516 161.289H209.653",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 155.08H214.315",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 161.289H214.315",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.84 155.08H218.978",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.84 161.289H218.978",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.498 155.08H223.636",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.498 161.289H223.636",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16 155.08H228.298",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16 161.289H228.298",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.822 155.08H232.96",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.822 161.289H232.96",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.486 155.08H237.624",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.486 161.289H237.624",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.145 155.08H242.282",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.145 161.289H242.282",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.807 155.08H246.944",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.807 161.289H246.944",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.471 155.08H251.219",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.471 161.289H251.608",
    stroke: "#615E66",
    strokeWidth: 0.297324
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.32 146.335C232.872 145.006 228.882 144.587 226.551 147.694C230.437 144.973 232.358 146.96 233.544 148.277C235.292 150.218 235.292 154.232 239.178 153.715C235.682 150.801 236.654 148.47 234.323 146.335H234.32Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.261 146.453C213.124 144.985 206.933 145.169 204.02 149.442C207.709 145.945 211.866 147.298 213.537 147.886C216.84 149.052 217.809 153.455 221.696 152.938C218.645 152.162 218.371 148.591 215.261 146.453Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.033 146.337C187.539 145.623 182.654 145.754 176.826 149.25C183.623 146.53 187.78 147.496 189.451 148.085C192.754 149.25 195.085 151.581 199.161 151.775C196.111 150.999 194.11 147.502 190.033 146.337Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.819 145.946C152.74 145.557 147.293 145.379 138.174 148.667C148.081 146.725 153.569 147.519 156.236 147.695C161.481 148.04 165.004 150.231 171.388 150.415C166.619 149.684 163.268 146.562 156.819 145.946Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5107 177.789H455.461V191.323H-24.5107V177.789Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.877 182.096L-21.8389 182.017",
    stroke: "white",
    strokeWidth: 0.436336,
    strokeDasharray: "2.18 2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.945 165.271H455.461V170.804H-24.945V165.271Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5107 166.832H455.461V174.214H-24.5107V166.832Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.209 174.215H355.964L389.046 172.061H428.421L455.209 174.215Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.1 174.215H271.021L299.271 172.061H338.647L387.099 174.215H387.1Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.952 174.215H107.955L155.236 172.061H247.308L285.952 174.215Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5107 191.094H455.461V194.584H-24.5107V191.094Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5107 174.295H455.461V177.786H-24.5107V174.295Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.9307 132.432H100.666V134.73H-16.9307V132.432Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.126 138.177L102.439 135.879H-19.4377L-17.7929 138.177H101.126Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4051 138.18H101.047V166.143H88.4051V138.18Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4051 138.18H101.047V140.862H88.4051V138.18Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0905 156.184H98.3672V166.143H91.0905V156.184Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9348 153.883H99.1289V154.648H89.9348V153.883Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4282 156.184L99.041 154.65H90.0844L91.005 156.184H98.4282Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0027 157.715H96.0664V166.141H93.0027V157.715Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.237 148.904H96.834V150.438H92.237V148.904Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7694 158.482H95.3027V162.314H93.7694V158.482Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.05899 138.18H88.4062V140.478H-5.05899V138.18Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.05899 140.477H88.4062V143.54H-5.05899V140.477Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8092 143.543H88.4062V166.144H83.8092V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1667 143.543H75.7637V166.144H71.1667V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3776 143.543H61.9746V166.144H57.3776V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3522 143.543H48.9492V166.144H44.3522V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2447 143.543H37.8418V166.144H33.2447V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8389 143.543H25.2012V166.144H19.8389V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43383 143.543H12.9453V166.144H6.43383V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.05835 143.543H1.45312V166.144H-5.05835V143.543Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7236 140.477H88.4062V141.626H85.7236V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1077 141.625H88.4062V166.141H86.1077V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0847 140.477H76.1484V141.626H73.0847V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4652 141.625H75.7637V166.141H73.4652V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2937 140.477H62.3574V141.626H59.2937V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6761 141.625H61.9746V166.141H59.6761V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2722 140.477H49.3359V141.626H46.2722V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6507 141.625H48.9492V166.141H46.6507V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8621 140.477H35.9258V141.626H32.8621V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2444 141.625H35.543V166.141H33.2444V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4558 140.477H22.5195V141.626H19.4558V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8382 141.625H22.1367V166.141H19.8382V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04951 140.477H9.11328V141.626H6.04951V140.477Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42997 141.625H8.72852V166.141H6.42997V141.625Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.757 131.282L101.619 130.133H-18.6602L-17.7983 131.282H100.757Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.757 132.432L101.619 131.283H-18.6602L-17.7983 132.432H100.757Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.641 135.882L103.529 134.732H-20.5643L-19.676 135.882H102.641Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5342 148.141C93.0526 148.141 91.8516 146.94 91.8516 145.458C91.8516 143.976 93.0526 142.775 94.5342 142.775C96.0157 142.775 97.2168 143.976 97.2168 145.458C97.2168 146.94 96.0157 148.141 94.5342 148.141Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5328 147.372C93.4755 147.372 92.6183 146.515 92.6183 145.457C92.6183 144.4 93.4755 143.543 94.5328 143.543C95.5901 143.543 96.4473 144.4 96.4473 145.457C96.4473 146.515 95.5901 147.372 94.5328 147.372Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.123 124.006L43.0151 125.539L40.142 130.136C40.8426 130.136 42.4786 130.098 43.3992 129.946C45.2374 128.873 45.0586 126.307 44.739 125.158L45.123 124.009V124.006Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6543 124.77L44.5463 126.109L41.6731 130.132C42.3738 130.132 44.0098 130.1 44.9304 129.965C46.7686 129.026 46.5898 126.781 46.2702 125.775L46.6543 124.77Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1855 125.156L46.0775 126.402L43.2045 130.137C43.9051 130.137 45.541 130.105 46.4616 129.982C48.2998 129.111 48.121 127.024 47.8015 126.091L48.1855 125.156Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1016 125.924L47.9936 126.976L45.1205 130.137C45.8212 130.137 47.4571 130.11 48.3777 130.005C50.2159 129.266 50.0371 127.504 49.7176 126.712L50.1016 125.924Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25 127.453L49.1421 128.125L46.2689 130.136C46.9696 130.136 48.6055 130.118 49.5261 130.051C51.3643 129.582 51.1855 128.459 50.8659 127.954L51.25 127.453Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3138 124.006L38.4218 125.539L41.2949 130.136C40.5942 130.136 38.9583 130.098 38.0377 129.946C36.1995 128.873 36.3783 126.307 36.6978 125.158L36.3138 124.009V124.006Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7787 124.77L36.8866 126.109L39.7598 130.132C39.0591 130.132 37.4231 130.1 36.5025 129.965C34.6643 129.026 34.8431 126.781 35.1627 125.775L34.7787 124.77Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2494 125.156L35.3574 126.402L38.2305 130.137C37.5298 130.137 35.8939 130.105 34.9733 129.982C33.1351 129.111 33.3139 127.024 33.6335 126.091L33.2494 125.156Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3314 125.924L33.4393 126.976L36.3125 130.137C35.6118 130.137 33.9758 130.11 33.0553 130.005C31.217 129.266 31.3958 127.504 31.7154 126.712L31.3314 125.924Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.181 127.453L32.2889 128.125L35.1621 130.136C34.4614 130.136 32.8255 130.118 31.9049 130.051C30.0667 129.582 30.2455 128.459 30.5651 127.954L30.181 127.453Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.718 129.367C39.3433 129.367 38.2288 128.252 38.2288 126.878C38.2288 125.503 39.3433 124.389 40.718 124.389C42.0926 124.389 43.207 125.503 43.207 126.878C43.207 128.252 42.0926 129.367 40.718 129.367Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7156 128.604C39.7635 128.604 38.9917 127.832 38.9917 126.88C38.9917 125.928 39.7635 125.156 40.7156 125.156C41.6677 125.156 42.4395 125.928 42.4395 126.88C42.4395 127.832 41.6677 128.604 40.7156 128.604Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2077 143.799L98.4188 143.072C98.4891 142.829 98.3044 142.582 98.0464 142.582H97.0965C97.0467 142.582 96.9998 142.574 96.9588 142.556L94.6925 141.685C94.5928 141.647 94.4814 141.653 94.3846 141.7L92.007 142.887C91.9103 142.937 91.7959 142.94 91.6933 142.899L91.2916 142.738C91.0805 142.653 90.843 142.77 90.7815 142.987L90.547 143.793C90.5235 143.875 90.5264 143.963 90.5616 144.039L90.8196 144.687C90.8695 144.805 90.8548 144.937 90.7844 145.042L90.6174 145.294C90.5529 145.394 90.5381 145.517 90.5704 145.628L90.8372 146.423C90.8724 146.534 90.8577 146.657 90.7903 146.757L90.632 146.992C90.5557 147.106 90.547 147.253 90.6085 147.376L90.8079 147.772C90.8607 147.88 90.8607 148.006 90.8079 148.115L90.5851 148.554C90.5352 148.651 90.5323 148.765 90.5733 148.868L90.8138 149.478C90.8636 149.595 90.8489 149.727 90.7785 149.833L90.6496 150.026C90.5645 150.155 90.5645 150.322 90.6496 150.451L90.7698 150.627C90.846 150.741 90.8548 150.888 90.7932 151.011L90.5939 151.407C90.5411 151.515 90.5411 151.642 90.5939 151.75L90.8196 152.199C90.8665 152.289 90.8577 152.398 90.7991 152.48C90.6759 152.668 90.8108 152.92 91.0366 152.92H97.9614C98.0904 152.92 98.2106 152.855 98.2839 152.75L98.4305 152.53C98.5067 152.415 98.5156 152.269 98.454 152.146L98.2546 151.75C98.2018 151.642 98.2018 151.515 98.2546 151.407L98.454 151.011C98.5156 150.888 98.5067 150.741 98.4305 150.627L98.3103 150.451C98.2253 150.322 98.2253 150.155 98.3103 150.026L98.4393 149.833C98.5097 149.727 98.5243 149.595 98.4745 149.478L98.2341 148.868C98.1931 148.765 98.196 148.651 98.2459 148.554L98.4687 148.115C98.5214 148.006 98.5214 147.88 98.4687 147.772L98.2546 147.346C98.2018 147.238 98.2018 147.112 98.2546 147.003L98.4774 146.564C98.5272 146.467 98.5302 146.353 98.4891 146.25L98.2488 145.64C98.1989 145.523 98.2136 145.391 98.2839 145.285L98.4452 145.045C98.5156 144.939 98.5302 144.808 98.4803 144.69L98.2224 144.042C98.1872 143.963 98.1842 143.875 98.2077 143.796V143.799Z",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7909 123.242H97.2168V130.138H88.7909V123.242Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8726 125.057V130.138H88.7871V123.459L86.8726 125.054V125.057Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9667 126.016L98.2338 129.827C98.1986 130.009 98.0373 130.138 97.8556 130.138H56.6113C56.4002 130.138 56.2272 129.965 56.2272 129.754V128.74C56.2272 128.652 56.2565 128.567 56.3122 128.499L56.9249 127.734C56.9718 127.676 56.9982 127.605 57.0041 127.532L57.18 125.782C57.183 125.746 57.1918 125.714 57.2035 125.682L57.7048 124.38C57.8192 124.075 58.2677 124.125 58.3146 124.451C58.3644 124.791 58.8394 124.823 58.9362 124.492L58.9508 124.43C59.0476 124.105 59.5108 124.113 59.5899 124.442L59.7013 124.884C59.7863 125.225 60.276 125.213 60.3464 124.87L60.3991 124.594C60.4577 124.316 60.8506 124.307 60.921 124.582L60.9445 124.679C61.009 124.931 61.3695 124.923 61.4194 124.668C61.4692 124.427 61.8064 124.401 61.8914 124.632L62.0673 125.125C62.1582 125.371 62.5129 125.356 62.5803 125.104C62.6595 124.82 63.07 124.849 63.1081 125.14L63.1169 125.186C63.155 125.494 63.5918 125.515 63.6651 125.213L63.8498 124.424C63.9202 124.143 64.313 124.122 64.4039 124.401L64.4743 124.603C64.5593 124.855 64.9258 124.811 64.9492 124.547C64.9727 124.286 65.3333 124.237 65.4212 124.483L65.5209 124.75C65.6177 125.019 65.9988 125.019 66.0955 124.75L66.2451 124.336C66.3447 124.064 66.7347 124.084 66.808 124.366L66.849 124.533C66.9135 124.802 67.3034 124.788 67.3504 124.512C67.3973 124.245 67.7725 124.219 67.8517 124.48L68.0188 125.034C68.095 125.277 68.4439 125.263 68.4967 125.016L68.5201 124.908C68.567 124.7 68.8544 124.679 68.9306 124.879C69.0098 125.09 69.3205 125.049 69.344 124.826V124.791C69.3704 124.556 69.6958 124.515 69.7779 124.738L69.8512 124.937C69.9479 125.201 70.3291 125.163 70.373 124.884L70.4082 124.668C70.4463 124.407 70.8128 124.395 70.8744 124.65L70.8832 124.682C70.9418 124.934 71.3054 124.917 71.3376 124.662L71.3581 124.515C71.3933 124.275 71.7422 124.269 71.7744 124.512C71.8126 124.741 72.135 124.755 72.1878 124.533L72.2405 124.319C72.305 124.058 72.6804 124.064 72.739 124.327L72.7859 124.539C72.8563 124.861 73.3136 124.861 73.384 124.539L73.3957 124.489C73.4661 124.166 73.9175 124.152 74.0084 124.468L74.0788 124.706C74.1814 125.066 74.6915 125.069 74.8029 124.709C74.9143 124.342 75.4362 124.351 75.5359 124.72L75.5652 124.838C75.6678 125.222 76.2161 125.216 76.307 124.826L76.4213 124.333C76.4946 124.034 76.9227 124.04 76.9813 124.342L77.0047 124.442C77.0633 124.735 77.4826 124.726 77.5295 124.43C77.5705 124.157 77.9458 124.119 78.0426 124.374L78.1833 124.741C78.3005 125.055 78.7609 124.999 78.8078 124.668C78.8547 124.316 79.3531 124.283 79.444 124.626L79.4967 124.838C79.5876 125.172 80.0567 125.192 80.171 124.867L80.2238 124.726C80.3264 124.445 80.7281 124.462 80.8073 124.75C80.8923 125.057 81.332 125.049 81.4053 124.738L81.4933 124.348C81.5636 124.055 81.9594 124.017 82.0826 124.292L82.1911 124.53C82.279 124.729 82.5751 124.7 82.6191 124.486C82.6719 124.245 83.0178 124.251 83.0647 124.492L83.1439 124.887C83.1967 125.154 83.5836 125.142 83.6188 124.873C83.654 124.603 84.041 124.591 84.0938 124.858L84.1231 125.005C84.1817 125.289 84.5863 125.289 84.6449 125.005L84.6743 124.858C84.7329 124.562 85.158 124.568 85.2108 124.864C85.2635 125.172 85.7121 125.148 85.7502 124.838C85.7854 124.541 86.2047 124.5 86.2838 124.791C86.3542 125.04 86.6972 125.063 86.7969 124.826L86.8086 124.799C86.9083 124.574 87.2308 124.571 87.3305 124.797L87.5474 125.292C87.6706 125.568 88.0487 125.6 88.2188 125.348L88.7202 124.594C88.8345 124.421 89.0954 124.436 89.1921 124.624C89.3065 124.858 89.6554 124.808 89.7023 124.55L89.7111 124.5C89.7697 124.198 90.1948 124.178 90.2769 124.477L90.2916 124.541C90.3678 124.817 90.743 124.846 90.8632 124.588L91.1711 123.911C91.2737 123.688 91.5991 123.715 91.6665 123.949L91.7633 124.298C91.8219 124.509 92.1298 124.483 92.1503 124.263C92.1709 124.046 92.4728 124.017 92.5373 124.225L92.5901 124.412C92.6605 124.635 92.9742 124.635 93.0416 124.412L93.0914 124.245C93.1764 123.967 93.5751 123.976 93.6426 124.257L93.6778 124.389C93.7423 124.659 94.1293 124.644 94.1791 124.371C94.226 124.113 94.5807 124.084 94.6746 124.33L94.7625 124.574C94.871 124.873 95.302 124.855 95.387 124.547L95.4398 124.354C95.5131 124.078 95.9 124.069 95.9909 124.339C96.0759 124.603 96.4512 124.603 96.5363 124.339L96.5509 124.298C96.6418 124.023 97.0347 124.023 97.1256 124.298L97.2604 124.703C97.3249 124.899 97.5858 124.946 97.7119 124.785C97.8702 124.591 98.1781 124.7 98.1781 124.949V125.688C98.1781 125.899 98.4419 125.993 98.5768 125.831C98.7263 125.653 99.0136 125.79 98.9726 126.019L98.9667 126.016Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.0052 126.016L-15.2722 129.827C-15.237 130.009 -15.0758 130.138 -14.894 130.138H26.3503C26.5614 130.138 26.7344 129.965 26.7344 129.754V128.74C26.7344 128.652 26.705 128.567 26.6493 128.499L26.0366 127.734C25.9897 127.676 25.9633 127.605 25.9575 127.532L25.7815 125.782C25.7786 125.746 25.7699 125.714 25.7581 125.682L25.2567 124.38C25.1424 124.075 24.6939 124.125 24.647 124.451C24.5971 124.791 24.1222 124.823 24.0254 124.492L24.0107 124.43C23.914 124.105 23.4508 124.113 23.3716 124.442L23.2603 124.884C23.1752 125.225 22.6856 125.213 22.6152 124.87L22.5625 124.594C22.5038 124.316 22.111 124.307 22.0406 124.582L22.0172 124.679C21.9527 124.931 21.592 124.923 21.5422 124.668C21.4924 124.427 21.1552 124.401 21.0702 124.632L20.8943 125.125C20.8034 125.371 20.4487 125.356 20.3812 125.104C20.3021 124.82 19.8916 124.849 19.8535 125.14L19.8447 125.186C19.8066 125.494 19.3698 125.515 19.2965 125.213L19.1117 124.424C19.0414 124.143 18.6486 124.122 18.5577 124.401L18.4873 124.603C18.4023 124.855 18.0358 124.811 18.0123 124.547C17.9889 124.286 17.6283 124.237 17.5403 124.483L17.4406 124.75C17.3439 125.019 16.9628 125.019 16.866 124.75L16.7165 124.336C16.6168 124.064 16.2269 124.084 16.1536 124.366L16.1125 124.533C16.048 124.802 15.6581 124.788 15.6112 124.512C15.5643 124.245 15.189 124.219 15.1099 124.48L14.9428 125.034C14.8665 125.277 14.5177 125.263 14.4649 125.016L14.4414 124.908C14.3945 124.7 14.1072 124.679 14.031 124.879C13.9519 125.09 13.641 125.049 13.6176 124.826V124.791C13.5912 124.556 13.2658 124.515 13.1837 124.738L13.1104 124.937C13.0136 125.201 12.6325 125.163 12.5885 124.884L12.5534 124.668C12.5153 124.407 12.1488 124.395 12.0872 124.65L12.0784 124.682C12.0198 124.934 11.6562 124.917 11.624 124.662L11.6035 124.515C11.5683 124.275 11.2194 124.269 11.1871 124.512C11.149 124.741 10.8265 124.755 10.7738 124.533L10.721 124.319C10.6565 124.058 10.2813 124.064 10.2226 124.327L10.1757 124.539C10.1053 124.861 9.64794 124.861 9.57758 124.539L9.56584 124.489C9.49548 124.166 9.04403 124.152 8.95314 124.468L8.88278 124.706C8.78017 125.066 8.27005 125.069 8.15864 124.709C8.04723 124.342 7.52538 124.351 7.42569 124.72L7.39635 124.838C7.29374 125.222 6.74548 125.216 6.6546 124.826L6.54029 124.333C6.467 124.034 6.03891 124.04 5.98027 124.342L5.95687 124.442C5.89823 124.735 5.47898 124.726 5.43207 124.43C5.39102 124.157 5.01576 124.119 4.91901 124.374L4.77829 124.741C4.65808 125.055 4.20069 124.999 4.15378 124.668C4.10687 124.316 3.60849 124.283 3.51761 124.626L3.46485 124.838C3.37397 125.172 2.90487 125.192 2.79053 124.867L2.73778 124.726C2.63516 124.445 2.23351 124.462 2.15436 124.75C2.06933 125.057 1.62955 125.049 1.55626 124.738L1.46829 124.348C1.39793 124.055 1.00214 124.017 0.879001 124.292L0.770491 124.53C0.682538 124.729 0.386439 124.7 0.342462 124.486C0.28969 124.245 -0.0562659 124.251 -0.103174 124.492L-0.182338 124.887C-0.23511 125.154 -0.622068 125.142 -0.65725 124.873C-0.692431 124.603 -1.07946 124.591 -1.13223 124.858L-1.16151 125.005C-1.22014 125.289 -1.62474 125.289 -1.68337 125.005L-1.71272 124.858C-1.77136 124.562 -2.19642 124.568 -2.24919 124.864C-2.30196 125.172 -2.75055 125.148 -2.78866 124.838C-2.82384 124.541 -3.24311 124.5 -3.32227 124.791C-3.39263 125.04 -3.73565 125.063 -3.83533 124.826L-3.84707 124.799C-3.94675 124.574 -4.26918 124.571 -4.36886 124.797L-4.58581 125.292C-4.70894 125.568 -5.08716 125.6 -5.2572 125.348L-5.75852 124.594C-5.87286 124.421 -6.13382 124.436 -6.23057 124.624C-6.34491 124.858 -6.69379 124.808 -6.7407 124.55L-6.7495 124.5C-6.80814 124.198 -7.23323 124.178 -7.31532 124.477L-7.32999 124.541C-7.40622 124.817 -7.78147 124.846 -7.90167 124.588L-8.20952 123.911C-8.31214 123.688 -8.63755 123.715 -8.70498 123.949L-8.80175 124.298C-8.86039 124.509 -9.16824 124.483 -9.18877 124.263C-9.20929 124.046 -9.51121 124.017 -9.57571 124.225L-9.62853 124.412C-9.6989 124.635 -10.0125 124.635 -10.08 124.412L-10.1299 124.245C-10.2149 123.967 -10.6136 123.976 -10.681 124.257L-10.7162 124.389C-10.7807 124.659 -11.1677 124.644 -11.2175 124.371C-11.2644 124.113 -11.6192 124.084 -11.713 124.33L-11.801 124.574C-11.9094 124.873 -12.3404 124.855 -12.4254 124.547L-12.4782 124.354C-12.5515 124.078 -12.9385 124.069 -13.0294 124.339C-13.1144 124.603 -13.4897 124.603 -13.5747 124.339L-13.5894 124.298C-13.6803 124.023 -14.0731 124.023 -14.164 124.298L-14.2988 124.703C-14.3633 124.899 -14.6243 124.946 -14.7503 124.785C-14.9087 124.591 -15.2165 124.7 -15.2165 124.949V125.688C-15.2165 125.899 -15.4803 125.993 -15.6152 125.831C-15.7647 125.653 -16.0521 125.79 -16.011 126.019L-16.0052 126.016Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.293178,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.543 129.944L26.4726 126.711C26.4609 126.165 26.0181 125.731 25.4728 125.731C24.9363 125.731 24.4936 126.157 24.4731 126.693L24.35 129.944L24.2415 126.649C24.221 126.139 23.8017 125.731 23.2916 125.731C22.7815 125.731 22.3622 126.136 22.3417 126.646L22.2186 129.944L22.0925 126.675C22.072 126.148 21.641 125.731 21.1133 125.731C20.5856 125.731 20.1517 126.148 20.1341 126.675L20.0109 129.944L19.8585 126.561C19.835 126.095 19.451 125.729 18.9848 125.729C18.5069 125.729 18.1141 126.118 18.1141 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1172 129.944L18.0468 126.711C18.0351 126.165 17.5924 125.731 17.047 125.731C16.5105 125.731 16.0679 126.157 16.0473 126.693L15.9242 129.944L15.8157 126.649C15.7952 126.139 15.3759 125.731 14.8658 125.731C14.3557 125.731 13.9364 126.136 13.9159 126.646L13.7928 129.944L13.6668 126.675C13.6462 126.148 13.2152 125.731 12.6875 125.731C12.1598 125.731 11.7259 126.148 11.7083 126.675L11.5852 129.944L11.4327 126.561C11.4093 126.095 11.0252 125.729 10.559 125.729C10.0812 125.729 9.68831 126.118 9.68831 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 129.944L9.61714 126.711C9.60541 126.165 9.15974 125.731 8.61736 125.731C8.08084 125.731 7.63817 126.157 7.61764 126.693L7.49453 129.944L7.38602 126.649C7.3655 126.139 6.94626 125.731 6.43613 125.731C5.926 125.731 5.50676 126.136 5.48623 126.646L5.36312 129.944L5.23707 126.675C5.21655 126.148 4.78555 125.731 4.25783 125.731C3.73011 125.731 3.29618 126.148 3.27859 126.675L3.15548 129.944L3.00302 126.561C2.97957 126.095 2.59551 125.729 2.12936 125.729C1.65148 125.729 1.25863 126.118 1.25863 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26172 129.944L1.19136 126.711C1.17963 126.165 0.733955 125.731 0.191575 125.731C-0.344941 125.731 -0.787614 126.157 -0.808137 126.693L-0.931249 129.944L-1.03976 126.649C-1.06028 126.139 -1.47952 125.731 -1.98965 125.731C-2.49978 125.731 -2.91903 126.136 -2.93955 126.646L-3.06266 129.944L-3.18871 126.675C-3.20923 126.148 -3.64023 125.731 -4.16795 125.731C-4.69567 125.731 -5.1296 126.148 -5.14719 126.675L-5.2703 129.944L-5.42276 126.561C-5.44621 126.095 -5.83027 125.729 -6.29643 125.729C-6.77431 125.729 -7.16716 126.118 -7.16716 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9414 129.944L98.871 126.711C98.8593 126.165 98.4166 125.731 97.8713 125.731C97.3348 125.731 96.8921 126.157 96.8716 126.693L96.7484 129.944L96.64 126.649C96.6195 126.139 96.2002 125.731 95.69 125.731C95.1799 125.731 94.7607 126.136 94.7401 126.646L94.617 129.944L94.491 126.675C94.4705 126.148 94.0395 125.731 93.5117 125.731C92.984 125.731 92.5502 126.148 92.5326 126.675L92.4094 129.944L92.2569 126.561C92.2335 126.095 91.8494 125.729 91.3833 125.729C90.9054 125.729 90.5125 126.118 90.5125 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5117 129.944L90.4414 126.711C90.4296 126.165 89.987 125.731 89.4416 125.731C88.9051 125.731 88.4624 126.157 88.4419 126.693L88.3188 129.944L88.2103 126.649C88.1898 126.139 87.7705 125.731 87.2603 125.731C86.7502 125.731 86.331 126.136 86.3105 126.646L86.1873 129.944L86.0613 126.675C86.0408 126.148 85.6098 125.731 85.0821 125.731C84.5543 125.731 84.1205 126.148 84.1029 126.675L83.9797 129.944L83.8272 126.561C83.8038 126.095 83.4197 125.729 82.9536 125.729C82.4757 125.729 82.0828 126.118 82.0828 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0859 129.944L82.0156 126.711C82.0039 126.165 81.5612 125.731 81.0159 125.731C80.4793 125.731 80.0366 126.157 80.0161 126.693L79.893 129.944L79.7845 126.649C79.7639 126.139 79.3447 125.731 78.8346 125.731C78.3244 125.731 77.9052 126.136 77.8847 126.646L77.7616 129.944L77.6355 126.675C77.615 126.148 77.184 125.731 76.6563 125.731C76.1285 125.731 75.6947 126.148 75.6771 126.675L75.5539 129.944L75.4015 126.561C75.378 126.095 74.9939 125.729 74.5278 125.729C74.0499 125.729 73.6571 126.118 73.6571 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6602 129.944L73.5898 126.711C73.5781 126.165 73.1354 125.731 72.5901 125.731C72.0536 125.731 71.6108 126.157 71.5903 126.693L71.4672 129.944L71.3587 126.649C71.3382 126.139 70.9189 125.731 70.4088 125.731C69.8987 125.731 69.4794 126.136 69.4589 126.646L69.3358 129.944L69.2097 126.675C69.1892 126.148 68.7582 125.731 68.2305 125.731C67.7028 125.731 67.2688 126.148 67.2512 126.675L67.1281 129.944L66.9757 126.561C66.9522 126.095 66.5682 125.729 66.102 125.729C65.6241 125.729 65.2313 126.118 65.2313 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 129.944L65.1601 126.711C65.1484 126.165 64.7057 125.731 64.1604 125.731C63.6239 125.731 63.1811 126.157 63.1606 126.693L63.0375 129.944L62.929 126.649C62.9085 126.139 62.4892 125.731 61.9791 125.731C61.469 125.731 61.0497 126.136 61.0292 126.646L60.9061 129.944L60.78 126.675C60.7595 126.148 60.3285 125.731 59.8008 125.731C59.2731 125.731 58.8392 126.148 58.8216 126.675L58.6984 129.944L58.546 126.561C58.5225 126.095 58.1385 125.729 57.6723 125.729C57.1944 125.729 56.8016 126.118 56.8016 126.599V129.941",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0905 131.283H98.3672V133.582H91.0905V131.283Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.384 132.432H74.2347C73.6014 132.432 73.0854 132.945 73.0854 133.581C73.0854 134.214 73.5985 134.73 74.2347 134.73H75.384C76.0172 134.73 76.5332 134.217 76.5332 133.581C76.5332 132.948 76.0202 132.432 75.384 132.432Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8382 128.218C19.8382 127.584 20.3513 127.068 20.9875 127.068C21.6237 127.068 22.1367 127.581 22.1367 128.218V130.132H19.8382V128.218Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43388 128.218C6.43388 127.584 6.94699 127.068 7.58319 127.068C8.21938 127.068 8.73242 127.581 8.73242 128.218V130.132H6.43388V128.218Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.593 132.432H60.4436C59.8104 132.432 59.2944 132.945 59.2944 133.581C59.2944 134.214 59.8074 134.73 60.4436 134.73H61.593C62.2262 134.73 62.7422 134.217 62.7422 133.581C62.7422 132.948 62.2291 132.432 61.593 132.432Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3702 132.432H20.221C19.5877 132.432 19.0718 132.945 19.0718 133.581C19.0718 134.214 19.5848 134.73 20.221 134.73H21.3702C22.0035 134.73 22.5195 134.217 22.5195 133.581C22.5195 132.948 22.0064 132.432 21.3702 132.432Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96397 132.432H6.81474C6.18147 132.432 5.6655 132.945 5.6655 133.581C5.6655 134.214 6.18147 134.73 6.81474 134.73H7.96397C8.59724 134.73 9.11328 134.217 9.11328 133.581C9.11328 132.948 8.59724 132.432 7.96397 132.432Z",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.279 127.078C98.9922 127.175 97.9808 128.251 97.9808 129.561V130.136H100.279V127.078Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7875 127.078C90.0745 127.175 91.0859 128.251 91.0859 129.561V130.136H88.7875V127.078Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8499 128.218C73.8499 127.584 74.363 127.068 74.9992 127.068C75.6354 127.068 76.1484 127.581 76.1484 128.218V130.132H73.8499V128.218Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0589 128.218C60.0589 127.584 60.572 127.068 61.2082 127.068C61.8444 127.068 62.3574 127.581 62.3574 128.218V130.132H60.0589V128.218Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.293178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.355 170.597C440.542 171.102 443.758 172.87 445.542 173.757L445.585 176.376C445.708 176.529 445.97 176.968 446 177.492C446.029 177.923 445.7 178.626 445.444 179.083C445.353 179.245 445.178 179.34 444.992 179.34H418.674C418.373 179.34 418.129 179.098 418.129 178.797V177.607C418.129 176.529 419.3 175.642 420.094 175.335C420.73 175.088 422.892 174.205 424.567 173.794C424.567 173.794 427.114 171.597 430.832 170.634C433.297 169.996 436.182 170.095 438.357 170.595L438.355 170.597Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.196933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.786 177.121C435.321 177.839 427.684 177.935 424.174 177.891V178.919H445.488C445.661 178.577 446.003 177.816 446.003 177.506C446.003 177.197 445.661 176.608 445.488 176.351C443.947 176.307 440.251 176.403 437.786 177.121Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.851 180.688C424.155 180.688 425.213 179.678 425.213 178.433C425.213 177.187 424.155 176.178 422.851 176.178C421.546 176.178 420.488 177.187 420.488 178.433C420.488 179.678 421.546 180.688 422.851 180.688Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.851 179.459C423.442 179.459 423.922 179 423.922 178.434C423.922 177.869 423.442 177.41 422.851 177.41C422.259 177.41 421.779 177.869 421.779 178.434C421.779 179 422.259 179.459 422.851 179.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.923 173.871C431.384 174.154 426.359 173.871 426.359 173.871C429.077 171.752 431.627 171.111 433.464 171.059C438.812 170.906 440.149 172.485 440.149 172.485C440.149 172.485 437.015 173.526 433.923 173.873V173.871Z",
    fill: "url(#paint4_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.685 178.695C368.432 178.111 362.439 178.158 360.033 178.191C359.414 178.2 358.827 178.457 358.401 178.903L356.098 181.314C356.098 181.314 349.916 182.127 349.916 182.727V185.014C349.779 185.183 349.494 185.668 349.457 186.244C349.427 186.717 349.788 187.49 350.071 187.994C350.171 188.174 350.364 188.278 350.569 188.278H379.549C379.88 188.278 380.146 188.012 380.146 187.68V183.999C380.146 183.409 378.863 183.151 377.986 183.021C377.108 182.891 374.902 182.625 373.061 182.173C373.061 182.173 371.795 178.983 370.685 178.695Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M354.686 184.283C356.722 183.603 358.267 184.566 358.787 185.131C358.977 185.226 359.379 185.328 359.494 184.99C358.362 183.718 356.101 183.294 354.688 184.283H354.686Z",
    fill: "url(#paint5_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.747 185.414C366.989 185.414 377.729 185.414 379.709 185.838V187.818H350.02C349.829 187.442 349.455 186.602 349.455 186.262C349.455 185.922 349.832 185.273 350.02 184.99C351.717 184.942 359.916 185.414 362.743 185.414H362.745H362.747Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.006 182.938L349.965 182.654L349.943 184.039L352.038 183.524C352.358 183.446 352.335 182.983 352.008 182.938H352.006Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.074 189.762C377.585 189.762 378.811 188.511 378.811 186.968C378.811 185.425 377.585 184.174 376.074 184.174C374.562 184.174 373.336 185.425 373.336 186.968C373.336 188.511 374.562 189.762 376.074 189.762Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.074 188.236C376.76 188.236 377.316 187.669 377.316 186.969C377.316 186.269 376.76 185.701 376.074 185.701C375.388 185.701 374.832 186.269 374.832 186.969C374.832 187.669 375.388 188.236 376.074 188.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.199 189.762C357.71 189.762 358.936 188.511 358.936 186.968C358.936 185.425 357.71 184.174 356.199 184.174C354.687 184.174 353.461 185.425 353.461 186.968C353.461 188.511 354.687 189.762 356.199 189.762Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.199 188.236C356.885 188.236 357.441 187.669 357.441 186.969C357.441 186.269 356.885 185.701 356.199 185.701C355.513 185.701 354.957 186.269 354.957 186.969C354.957 187.669 355.513 188.236 356.199 188.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.229 182.301H372.557L370.663 179.194L364.584 178.77H359.494L356.809 181.598C356.809 181.598 360.767 182.301 364.231 182.301H364.229Z",
    fill: "url(#paint6_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.229 182.301H372.557L370.663 179.194L364.584 178.77H359.494L356.809 181.598C356.809 181.598 360.767 182.301 364.231 182.301H364.229Z",
    fill: "url(#paint7_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.16 178.877H364.961V182.454H365.16V178.877Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.151487
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.578 182.258L370.32 179.221V180.721L367.832 182.258H366.578Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.148 182.3L368.69 179.035L369.523 179.146L365.801 182.3H365.148Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.393 177.096C392.489 177.096 394.188 178.795 394.188 180.891C394.188 182.987 392.489 184.686 390.393 184.686C388.297 184.686 386.598 182.987 386.598 180.891C386.598 178.795 388.297 177.096 390.393 177.096Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.394 178.52H390.711C392.372 178.52 393.715 179.865 393.715 181.523C393.715 183.183 392.369 184.527 390.711 184.527H390.394C388.734 184.527 387.391 183.181 387.391 181.523C387.391 179.863 388.736 178.52 390.394 178.52Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.236 181.363V193.063",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.451 181.682L390.236 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.182 181.682L390.396 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.453 177.096C397.549 177.096 399.248 178.795 399.248 180.891C399.248 182.987 397.549 184.686 395.453 184.686C393.357 184.686 391.658 182.987 391.658 180.891C391.658 178.795 393.357 177.096 395.453 177.096Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.455 178.52H395.772C397.432 178.52 398.775 179.865 398.775 181.523C398.775 183.183 397.43 184.527 395.772 184.527H395.455C393.794 184.527 392.451 183.181 392.451 181.523C392.451 179.863 393.797 178.52 395.455 178.52Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.297 181.363V193.063",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.508 181.682L395.293 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.24 181.682L395.455 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.514 177.096C402.61 177.096 404.309 178.795 404.309 180.891C404.309 182.987 402.61 184.686 400.514 184.686C398.418 184.686 396.719 182.987 396.719 180.891C396.719 178.795 398.418 177.096 400.514 177.096Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.511 178.52H400.828C402.489 178.52 403.832 179.865 403.832 181.523C403.832 183.183 402.486 184.527 400.828 184.527H400.511C398.851 184.527 397.508 183.181 397.508 181.523C397.508 179.863 398.853 178.52 400.511 178.52Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.354 181.363V193.063",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.568 181.682L400.354 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.301 181.682L400.515 183.896",
    stroke: "#382456",
    strokeWidth: 0.242029
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6824 177.846C63.6795 177.846 65.2984 179.465 65.2984 181.462C65.2984 183.459 63.6795 185.078 61.6824 185.078C59.6853 185.078 58.0664 183.459 58.0664 181.462C58.0664 179.465 59.6853 177.846 61.6824 177.846Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6822 179.201H61.9843C63.5663 179.201 64.8462 180.483 64.8462 182.063C64.8462 183.645 63.564 184.925 61.9843 184.925H61.6822C60.1002 184.925 58.8203 183.643 58.8203 182.063C58.8203 180.481 60.1025 179.201 61.6822 179.201Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5293 181.914V193.062",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6394 182.215L61.5293 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5723 182.215L61.6823 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5007 177.846C68.4978 177.846 70.1167 179.465 70.1167 181.462C70.1167 183.459 68.4978 185.078 66.5007 185.078C64.5036 185.078 62.8848 183.459 62.8848 181.462C62.8848 179.465 64.5036 177.846 66.5007 177.846Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5025 179.201H66.8047C68.3866 179.201 69.6665 180.483 69.6665 182.063C69.6665 183.645 68.3843 184.925 66.8047 184.925H66.5025C64.9206 184.925 63.6406 183.643 63.6406 182.063C63.6406 180.481 64.9229 179.201 66.5025 179.201Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3516 181.914V193.062",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4617 182.215L66.3516 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3945 182.215L66.5047 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.323 177.846C73.3201 177.846 74.939 179.465 74.939 181.462C74.939 183.459 73.3201 185.078 71.323 185.078C69.3259 185.078 67.707 183.459 67.707 181.462C67.707 179.465 69.3259 177.846 71.323 177.846Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3228 179.201H71.6249C73.2069 179.201 74.4868 180.483 74.4868 182.063C74.4868 183.645 73.2046 184.925 71.6249 184.925H71.3228C69.7408 184.925 68.4609 183.643 68.4609 182.063C68.4609 180.481 69.7431 179.201 71.3228 179.201Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28 182.215L71.1699 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2129 182.215L71.323 184.325",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1699 181.914V193.062",
    stroke: "#382456",
    strokeWidth: 0.230611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2246 170.609V171.14L30.4207 171.034L23.2229 170.188H14.6488C14.415 170.188 14.2246 170.378 14.2246 170.612V170.609Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.084 172.41C-13.084 171.592 -12.4196 170.928 -11.6016 170.928H43.2736C44.5699 170.928 45.7817 171.57 46.5089 172.646C47.4936 174.105 48.2705 175.693 48.8137 177.368L48.8461 177.47C49.1924 178.537 49.3698 179.649 49.3698 180.77V185.748C49.3698 186.566 48.7054 187.23 47.8874 187.23H-11.6016C-12.4196 187.23 -13.084 186.566 -13.084 185.748V172.41Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9831 173.526L50.1107 174.106L49.3706 174.424C49.3706 173.456 48.4617 172.747 47.5225 172.98L46.8299 173.153L46.0898 172.201H48.3297C49.1239 172.201 49.8099 172.753 49.9831 173.528V173.526Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.6621 181.197H41.6266",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60352 181.301V187.228",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8613 181.301V187.228",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 181.301V187.228",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1621 181.301V187.228",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0176 181.301V187.228",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8887 181.723V187.226",
    stroke: "#76736C",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6033 179.503V178.232H33.7022C35.9031 178.232 37.0197 178.585 37.3011 178.763L42.9104 181.091L46.5093 181.725H49.3681C49.4395 182.007 49.5369 182.677 49.3681 183.102C47.6736 183.208 43.6527 182.996 42.9104 182.571C39.608 180.2 36.5934 179.537 35.5005 179.501H-11.6055L-11.6033 179.503Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58201 189.984C4.21943 189.984 5.54683 188.609 5.54683 186.913C5.54683 185.217 4.21943 183.842 2.58201 183.842C0.944585 183.842 -0.382812 185.217 -0.382812 186.913C-0.382812 188.609 0.944585 189.984 2.58201 189.984Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47597 188.288C3.23612 188.288 3.85234 187.672 3.85234 186.912C3.85234 186.151 3.23612 185.535 2.47597 185.535C1.71583 185.535 1.09961 186.151 1.09961 186.912C1.09961 187.672 1.71583 188.288 2.47597 188.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1836 189.984C36.821 189.984 38.1484 188.609 38.1484 186.913C38.1484 185.217 36.821 183.842 35.1836 183.842C33.5461 183.842 32.2188 185.217 32.2188 186.913C32.2188 188.609 33.5461 189.984 35.1836 189.984Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0775 188.288C35.8377 188.288 36.4539 187.672 36.4539 186.912C36.4539 186.151 35.8377 185.535 35.0775 185.535C34.3174 185.535 33.7012 186.151 33.7012 186.912C33.7012 187.672 34.3174 188.288 35.0775 188.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4738 186.172H9.7793V187.018H11.4738V186.172Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7296 186.172H18.0352V187.018H19.7296V186.172Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7785 186.172H26.084V187.018H27.7785V186.172Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1707 182.994H40.9004V183.84H42.1707V182.994Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1707 184.902H40.9004V185.749H42.1707V184.902Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6033 173.043C-11.6033 172.576 -11.2246 172.197 -10.7571 172.197H43.1204C44.0336 172.197 44.9425 172.338 45.8125 172.615L45.8774 172.637C46.4877 172.831 46.9984 173.251 47.3079 173.814L48.1043 175.264C49.2036 177.268 49.6819 179.555 49.4742 181.832H46.5093L42.9104 181.198L38.1472 179.189C36.8185 178.629 35.3923 178.341 33.9511 178.341H-11.6055V173.048L-11.6033 173.043Z",
    fill: "url(#paint8_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.293 172.518L46.9617 174.03C48.0611 176.521 48.628 179.213 48.628 181.936",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2207 178.343L38.5724 171.416H40.7797L32.2207 179.923V178.343Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8457 178.761L37.5155 171.457L37.7882 171.836L30.8479 179.14V178.761H30.8457Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 178.343L23.047 171.416V173.362L16.6953 179.925V178.345V178.343Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3184 178.761L21.9881 171.457L22.2608 171.836L15.3205 179.14V178.761H15.3184Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 178.343L6.67587 171.416V173.362L0.324219 179.925V178.345V178.343Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60352 172.197V178.599",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8613 172.197V178.599",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 172.197V178.88",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1621 172.197V178.739",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0176 172.197V181.302",
    stroke: "white",
    strokeWidth: 0.21641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3939 176.573V174.387C50.3939 174.231 50.2662 174.104 50.1104 174.104H49.7923C49.4417 174.104 49.1582 174.387 49.1582 174.738V176.22C49.1582 176.571 49.4417 176.856 49.7923 176.856H50.1104C50.2662 176.856 50.3939 176.729 50.3939 176.573Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.995 15.0367H189.451C190.291 15.0367 190.973 14.3562 190.973 13.5153C190.973 12.6756 190.292 11.9938 189.451 11.9938H187.462V11.4123C187.462 8.76825 184.627 7.09161 182.311 8.36409L181.128 9.01336V8.65874C181.128 6.00297 179.022 3.78005 176.367 3.73703C173.654 3.6914 171.441 5.87781 171.441 8.57921V9.01336L170.747 8.58964C168.509 7.22069 165.887 9.66524 167.096 11.9938H164.954C164.088 11.9938 163.393 12.7147 163.433 13.5883C163.472 14.407 164.176 15.0354 164.995 15.0354V15.0367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.22 75.3007H384.543C383.863 75.3007 383.283 74.7563 383.296 74.0782C383.309 73.3778 382.746 72.8075 382.049 72.8075H374.486C373.825 72.8075 373.265 72.3523 373.087 71.7151C372.416 69.3129 369.589 68.005 367.259 69.3333L366.273 69.8944C365.882 70.1173 365.385 69.9483 365.21 69.534C364.305 67.3882 362.111 66.0765 359.792 66.2976L359.486 66.3273C356.749 66.5874 354.659 68.8856 354.659 71.6333C354.659 72.2817 354.134 72.8056 353.487 72.8056H352.209C351.529 72.8056 350.949 73.35 350.962 74.0281C350.975 74.7062 350.412 75.2988 349.716 75.2988H349.301C348.385 75.2988 347.585 75.9899 347.525 76.904C347.46 77.9054 348.253 78.7377 349.242 78.7377H352.811C353.396 78.7377 353.898 79.2058 353.886 79.7911C353.875 80.3948 354.36 80.8872 354.96 80.8872H376.244C377.431 80.8872 378.393 79.9248 378.393 78.7377H386.159C387.075 78.7377 387.875 78.0465 387.935 77.1325C388 76.1311 387.207 75.2988 386.218 75.2988L386.22 75.3007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.233 56.669H66.6102C65.1879 56.669 64.0332 55.5142 64.0332 54.0919C64.0332 52.6696 65.1851 51.5149 66.6102 51.5149H80.1207V50.5291C80.1207 46.0538 84.9199 43.2148 88.8432 45.3694L90.8457 46.4678V45.7327C90.8457 41.2039 94.5184 37.5312 99.0472 37.5312C103.576 37.5312 107.249 41.2039 107.249 45.7327V46.4678L108.423 45.7496C112.214 43.4317 116.653 47.5691 114.608 51.5149H118.236C119.658 51.5149 120.813 52.6696 120.813 54.0919C120.813 55.5142 119.661 56.669 118.236 56.669H118.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.543 383.262V193.543L-0.57254 193.543V383.262L429.543 383.262Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.545 430.916V407.535L-0.570587 407.535V430.916L429.545 430.916Z",
    fill: "url(#paint9_linear_5001_64747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.033 345.203L-1.13086 345.948L-0.572293 410.572H429.754L430.033 345.203Z",
    fill: "#FFF5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5001_64747",
    x1: -226.836,
    y1: 173.101,
    x2: -226.836,
    y2: 87.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5001_64747",
    x1: -226.836,
    y1: 173.101,
    x2: -226.836,
    y2: 87.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5001_64747",
    x1: 32.0695,
    y1: 107.374,
    x2: 32.0695,
    y2: 189.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5001_64747",
    x1: 647.301,
    y1: 189.187,
    x2: 647.301,
    y2: 71.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5001_64747",
    x1: 433.254,
    y1: 171.049,
    x2: 433.254,
    y2: 173.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5001_64747",
    x1: 359.516,
    y1: 184.661,
    x2: 353.435,
    y2: 183.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5001_64747",
    x1: 356.809,
    y1: 180.535,
    x2: 372.557,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5001_64747",
    x1: 364.683,
    y1: 178.77,
    x2: 364.683,
    y2: 182.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5001_64747",
    x1: 18.958,
    y1: 172.197,
    x2: 18.958,
    y2: 181.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5001_64747",
    x1: 214.487,
    y1: 407.535,
    x2: 214.487,
    y2: 430.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5001_64747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 447.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroRulesBg);
export default __webpack_public_path__ + "static/media/MetroRulesBg.82af04b4985ff152bfd2.svg";
export { ForwardRef as ReactComponent };